 <template>

  <html lang="en">
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, shrink-to-fit=no"
      />

      <title>
        BTA Group : Bimbingan Belajar Online/Offline Terbaik No 1 Pilihan
        Keluarga Indonesia
      </title>
      <meta
        name="google-site-verification"
        content="irvXi25F9xnCfRglR3SgfhW3ISCEfusZ0hGAmCNokaA"
      />
      <!-- Global site tag (gtag.js) - Google Analytics -->
    </head>

    <body>

      <!-- ===============================================-->
      <!--    Popup-->
      <!-- ===============================================-->

 		<b-modal
      v-model="popup"
      size="md"
      modal-class="border-0"
      header-class="background-primary"
      footer-class="justify-content-center"
      v-bind:centered="true"
      v-bind:hide-footer="true"
    >
      
      <!-- HEADER --> 
      <!------------>   
    
      <template slot="modal-header">
        <h4
          class="container text-uppercase text-white font-weight-bold text-center mb-0"
        >
          UPDATE TERBARU BTA
        </h4>
      </template>

      <!-- BODY --> 
      <!------------>

      <div class="d-block text-center p-3">

        <!-- NOTIF TO -->
						<!-- script TO line 1349 -->
						<!-- script TO di file layout header line 327 -->


        <div class="rounded p-3 mb-4 text-left shadow-sm" 
             style="background-color: #fff3cd; border-left: 5px solid #ffc107;">
             
          <div class="d-flex align-items-center mb-2">
            <div class="mr-3 display-4">📢</div> 
            <div>
              <h5 class="font-weight-bold text-dark mb-0" style="line-height: 1.2;">
                HASIL TO & ANALISIS SUDAH KELUAR!
              </h5>
              <small class="text-muted">Cek evaluasi belajarmu sekarang.</small>
            </div>
          </div>

          <b-button 
            block 
            variant="danger" 
            class="font-weight-bold mt-2 shadow-sm py-2"
            style="border-radius: 50px; font-size: 1rem;"
            @click="checkLoginAndGo"
          >
            LIHAT NILAI SAYA SEKARANG &rarr;
          </b-button>
        </div>

        
        <!-- SOSMED -->

        <div class="d-flex overflow-auto mb-3" style="scroll-snap-type: x mandatory; gap: 15px; padding-bottom: 10px;">

          <!-- Berita 1 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center;">
              <a href="https://keberhasilan.btagroup.co.id/sma2026.html" target="_blank" rel="noopener noreferrer" style="display: block;">
                <img 
                  src="/static/images/page/about/popupselamat2026.png" 
                  alt="Poster Pengumuman" 
                  style="width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
              </a>
            </div>

            <!-- Berita 2 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center;">
              <a href="https://api.whatsapp.com/send?phone=6285772897428&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Kota+Wisata+Cibubur%3F" target="_blank" rel="noopener noreferrer" style="display: block;">
                <img 
                  src="/static/images/page/about/CaBarBTA8KotWis.jpeg" 
                  alt="Poster Pengumuman" 
                  style="width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
              </a>
            </div>

            <!-- Berita 3 -->
            <div style="flex: 0 0 90%; scroll-snap-align: center; display: flex; flex-direction: column;">
              <iframe 
                src="https://www.instagram.com/p/DZIGRj2km4g/embed" 
                width="100%" 
                frameborder="0" 
                scrolling="no" 
                allowtransparency="true"
                style="flex-grow: 1; max-width: 100%; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
              </iframe>
            </div>
        </div>

        <div class="mt-4">
            <h5 class="font-weight-bold text-dark" style="font-size: 1.1rem;">Mau Info Lebih Lanjut?</h5>
            <p class="text-muted mb-4 small">
              Dapatkan update bimbel, tips belajar & kegiatan seru BTA lainnya. 
              <br>Yuk, follow kami!
            </p>
            
            <div class="d-flex flex-wrap justify-content-center align-items-center">
                <a href="https://www.instagram.com/btagroup_" target="_blank" class="btn btn-primary m-1 btn-sm" style="background-color: #E1306C; border-color: #E1306C; min-width: 120px;">
                    Instagram
                </a>
                
                <a href="https://www.tiktok.com/@btagroup_" target="_blank" class="btn btn-dark m-1 btn-sm" style="background-color: #000000; border-color: #000000; min-width: 120px;">
                    TikTok
                </a>
            </div>
        </div>

        <!-- TUTUP -->

        <button
        v-on:click="popup = false"
        class="btn btn-sm btn-outline-danger px-3 mt-5 mb-3 d-block mx-auto"
        style="font-size: 0.8rem;"
        >
        Tutup
        </button>

      </div>
    </b-modal>

      <!-- ===============================================-->
      <!--    Main Content-->
      <!-- ===============================================-->

<main class="main" id="top">

        <section class="py-1" id="banners">
          <div class="container">
            <div class="row flex-center h-100">
              <div
                class="carousel slide"
                id="carouselBanners"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active" data-bs-interval="3000">
                    <div class="row h-100 justify-content-center">
                      <div class="mb-4">
                        <div class="card h-100 shadow card-span p-3">
                          <div class="card-body">
                            <div class="d-flex align-items-center">
                              <a href="https://api.whatsapp.com/send?phone=6285772897428&text=Halo%2C+boleh+tanya+mengenai+Progam+Bimbingan+di+BTA+8+Kota+Wisata+Cibubur%3F" target="_blank"
                                ><img
                                  class="img-fluid d-block"
                                  src="/static/images/page/about/BannerCaBarBTA8KotWis.jpeg"
                                  style="width: 4000px"
                                  alt="Cabang Baru BTA 8 Kota Wisata"
                              /></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <div class="carousel-item" data-bs-interval="3000">
                    <div class="row h-100 justify-content-center">
                      <div class="mb-4">
                        <div class="card h-100 shadow card-span p-3">
                          <div class="card-body">
                            <div class="d-flex align-items-center">
                              <a href="https://btagroup.co.id/contact" target="_blank"
                                ><img
                                  class="img-fluid d-block"
                                  src="/static/images/page/about/BannerDaftar2627.jpeg"
                                  style="width: 4000px"
                                  alt="Ayo Mendaftar!"
                              /></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <div class="carousel-item" data-bs-interval="3000">
                    <div class="row h-100 justify-content-center">
                      <div class="mb-4">
                        <div class="card h-100 shadow card-span p-3">
                          <div class="card-body">
                            <div class="d-flex align-items-center">
                              <a href="https://keberhasilan.btagroup.co.id/sma2026.html" target="_blank"
                                ><img
                                  class="img-fluid d-block"
                                  src="/static/images/page/about/BannerSelamatPTN2526.jpeg"
                                  style="width: 4000px"
                                  alt="Selamat PTN"
                              /></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-5 flex-center">
                  <div class="col-auto position-relative z-index-2">
                    <ol class="carousel-indicators">
                      <li
                        class="active mx-2"
                        data-bs-target="#carouselBanners"
                        data-bs-slide-to="0"
                      ></li>
                      <li
                        class="mx-2"
                        data-bs-target="#carouselBanners"
                        data-bs-slide-to="1"
                      ></li>
                      <li
                        class="mx-2"
                        data-bs-target="#carouselBanners"
                        data-bs-slide-to="2"
                      ></li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of .container-->
        </section>

        <!--<div data-ride="carousel" class="carousel slide text-center bg-100" id="carousel-1">
    		<div class="carousel-inner">
        		<div class="carousel-item"><a href="https://keberhasilan.btagroup.co.id/sma.html"><img class="img-fluid w-100 d-block" src="/static/images/page/about/selamat_alumni2021-low-.png" style="width: 80%;" alt="Slide Image" /></a></div>
        		<div class="carousel-item"><a href="#home"><img class="img-fluid w-100 d-block" src="/static/images/page/about/banner2021-2022-1-low.png" style="width: 80%;" alt="Slide Image" /></a></div>
    		</div>
		<div><a href="#carousel-1" role="button" data-slide="prev" class="carousel-control-prev">
			<span aria-hidden="true" class="carousel-control-prev-icon"></span>
			<span class="sr-only">Previous</span>
		     </a>
		     <a href="#carousel-1" role="button" data-slide="next" class="carousel-control-next">
			<span aria-hidden="true" class="carousel-control-next-icon"></span>
			<span class="sr-only">Next</span>
		     </a>
		</div>
		<ol class="carousel-indicators">
        		<li data-target="#carousel-1" data-slide-to="0"></li>
        		<li data-target="#carousel-1" data-slide-to="1"></li>
    		</ol>
	</div>
	<div class="row text-center bg-100">
    		<div class="col"><a href="#home"><img src="/static/images/page/about/banner2021-2022-1-low.png" style="width: 80%;" /></a></div>
	</div>-->

        <section class="py-1" id="home">
          <div
            class="bg-holder d-none d-md-block"
            style="
              background-image: url(/static/images/page/about/natasya-home-new-resize2.png);
              background-position: right bottom;
              background-size: contain;
              margin-top: 5.625rem;
            "
          ></div>
          <!--/.bg-holder-->

          <!--<div class="bg-holder d-block d-md-none" style="background-image:url(/static/images/page/about/hero-bg-new1.png);background-position:right top;background-size:contain;margin-top:5.625rem;">
        </div>-->
          <!--/.bg-holder-->

          <div class="container">
            <div class="row align-items-center min-vh-md-75">
              <div class="col-md-7 col-lg-6 py-6 text-sm-start text-center">
                <h1
                  class="mt-6 mb-sm-4 display-4 fw-light lh-sm fs-4 fs-lg-5 fs-xxl-7"
                >
                  Bimbingan Belajar <span class="text-primary">Terbaik</span
                  ><br class="d-block d-lg-none d-xl-block" />Untuk Pelajar di
                  Seluruh Indonesia
                </h1>
                <!--<p class="mb-5 fs-1 lh-lg">We are always availed to consult on taking your higher education to the next level so you can stay competitive in the global world.</p>--><a
                  class="btn btn-lg btn-primary hover-top btn-glow"
                  href="#cabang"
                  >Pilih Cabang
                  <svg
                    class="bi bi-arrow-right-short ms-2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                    ></path></svg
                ></a>
                <div class="mt-5 mt-xl-6">
                  <ul class="list-unstyled list-inline mb-0">
                    <li class="list-inline-item me-3">
                      <a
                        href="https://www.youtube.com/channel/UCkPXrArTezFJ1nRNXX-csug"
                      >
                        <svg
                          class="bi bi-youtube text-youtube"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"
                          ></path></svg
                      ></a>
                    </li>
                    <li class="list-inline-item me-3">
                      <a href="https://www.instagram.com/btagroup_/">
                        <svg
                          class="bi bi-instagram text-instagram text-instagram"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                          ></path></svg
                      ></a>
                    </li>
                    <li class="list-inline-item me-3">
                      <a href="https://web.facebook.com/btagroupofficial">
                        <svg
                          class="bi bi-facebook text-facebook text-facebook"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                          ></path></svg
                      ></a>
                    </li>
                    <li class="list-inline-item me-3">
                      <a href="https://www.tiktok.com/@btagroup_">
                        <svg
                          class="bi bi-tiktok text-tiktok text-tiktok"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
                          ></path></svg
                      ></a>
                    </li>
                    <li class="list-inline-item me-3">
                      <a href="https://twitter.com/btagroup_?lang=en">
                        <svg
                          class="bi bi-twitter text-twitter text-twitter"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
                          ></path></svg
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!-- <section> begin ============================-->
        <section id="cabang" class="bg-100 py-5">
          <div class="container">
            <div class="row">
              <div class="col-12 mx-auto align-items-center text-center">
                <h6 class="fw-light fs-3 fs-lg-4 lh-sm mb-4">
                  Cabang BTA Group
                </h6>
                <div class="row h-100 justify-content-center">
                  <div v-for="(branch, index) in primaryBranches" v-if="!branch.isHidden" v-bind:key="branch.id" class="col-sm-6 col-lg-4 col-xl-3 mb-4">
                      <a v-if="getWaLink(branch)" v-bind:href="getWaLink(branch)" class="cabang-link" target="_blank">
                          <div class="cabang-card">
                              <img v-bind:src="branch.imageUrl" v-bind:alt="branch.name">
                          </div>
                      </a>
                      <div v-else class="cabang-link">
                          <div class="cabang-card">
                              <img v-bind:src="branch.imageUrl" v-bind:alt="branch.name">
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of .container-->
        </section>
        <!-- <section> close ============================-->
        <!-- ============================================-->

        <section id="alumni">
          <div class="row text-center">
            <div class="col">
              <h5 class="fw-light fs-3 fs-lg-5 lh-sm mb-3">Lulusan Kami</h5>
              <a href="https://keberhasilan.btagroup.co.id/sma.html"
                ><img
                  src="/static/images/page/about/alumni.jpg"
                  style="width: 80%"
              /></a>
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!-- <section> begin ============================-->
        <section id="services">
          <div class="container">
            <div class="row">
              <div class="col-lg-7 mx-auto text-center mb-4">
                <h5 class="fw-light fs-3 fs-lg-5 lh-sm mb-3">Produk Kami</h5>
                <!--<p class="mb-5">Executive Trade International is an University Application Centre, guiding Bangladeshi students to Australian, British, Canadian and Irish universities!</p>-->
              </div>
            </div>
            <div class="row flex-center h-100">
              <div class="col-xl-9">
                <div class="row justify-content-center">
                  <div class="col-md-5 mb-5">
                    <div
                      class="card h-100 shadow px-4 px-md-2 px-lg-3 card-span pt-4"
                    >
                      <div class="text-center text-md-start card-hover">
                        <div class="card-body">
                          <h5 class="fw-light fs-2 heading-color">
                            Kelas 8/9 SMP
                          </h5>
                          <p class="mt-3 mb-md-0 mb-lg-3">
                            Bimbingan untuk mempersiapkan Ujian Sekolah dan
                            Seleksi Masuk SMA Favorit
                          </p>
                          <a
                            href="#"
                            v-on:click.prevent="modal9 = true"
                            class="d-block mb-5"
                          >
                            Lihat Detail
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 mb-5">
                    <div
                      class="card h-100 shadow px-4 px-md-2 px-lg-3 card-span pt-4"
                    >
                      <div class="text-center text-md-start card-hover">
                        <div class="card-body">
                          <h6 class="fw-light fs-2 heading-color">
                            Kelas 10/11 SMA
                          </h6>
                          <p class="mt-3 mb-md-0 mb-lg-3">
                            Bimbingan yang fokus pada penguatan konsep dasar dan
                            review materi sekolah yang disesuaikan dengan
                            kurikulum yang berlaku sehingga mampu mengakomodasi
                            kebutuhan siswa untuk mencapai nilai rapor yang
                            memuaskan
                          </p>
                          <a
                            href="#"
                            v-on:click.prevent="modal10 = true"
                            class="d-block mb-5"
                          >
                            Lihat Detail
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 mb-5">
                    <div
                      class="card h-100 shadow px-4 px-md-2 px-lg-3 card-span pt-4"
                    >
                      <div class="text-center text-md-start card-hover">
                        <div class="card-body">
                          <h6 class="fw-light fs-2 heading-color">
                            Kelas 12 SMA
                          </h6>
                          <p class="mt-3 mb-md-0 mb-lg-3">
                            Bimbingan untuk mempersiapkan Ujian Sekolah dan
                            Seleksi Masuk Perguruan Tinggi Favorit
                          </p>
                          <a
                            href="#"
                            v-on:click.prevent="modal12 = true"
                            class="d-block mb-5"
                          >
                            Lihat Detail
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 mb-5">
                    <div
                      class="card h-100 shadow px-4 px-md-2 px-lg-3 card-span pt-4"
                    >
                      <div class="text-center text-md-start card-hover">
                        <div class="card-body">
                          <h6 class="fw-light fs-2 heading-color">
                            Program Alumni
                          </h6>
                          <p class="mt-3 mb-md-0 mb-lg-3">
                            Bimbingan untuk penguatan konsep dasar dan latihan
                            soal kelas X sampai kelas XII untuk persiapan Ujian
                            Seleksi Masuk Perguruan Tinggi Favorit
                          </p>
                          <a
                            href="#"
                            v-on:click.prevent="modalAl = true"
                            class="d-block mb-5"
                          >
                            Lihat Detail
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of .container-->

          <b-modal
            v-model="modal9"
            size="lg"
            modal-class="border-0"
            header-class="background-primary"
            footer-class="justify-content-center"
            v-bind:centered="true"
            v-bind:hide-footer="true"
          >
            <template slot="modal-header">
              <h4
                class="container text-uppercase text-white font-weight-bold text-center mb-0"
              >
                Fasilitas yang didapatkan:
              </h4>
            </template>
            <div class="container px-5 py-2">
              <p class="font-weight-medium mb-1">
                Fasilitas Kelas 8/9 SMP: <br />
                1. Sesi pertemuan belajar tatap muka/secara daring minimal 4
                sesi/pekan.<br />
                2. Buku kumpulan materi dan ribuan soal-soal latihan
                terlengkap.<br />
                3. Tes evaluasi berkala untuk mengetahui perkembangan siswa
                secara daring.<br />
                4. Tambahan belajar untuk persiapan ujian masuk SMA Swasta
                Favorit.<br />
                5. Sistem akademik yang mencakup laporan hasil belajar, laporan
                kehadiran, serta materi pembelajaran yang dapat diakses 24
                jam<br />
                6. Sistem forum tanya jawab pada website yang bisa diakses 24
                jam.<br />
                7. Standby Teacher terjadwal.
              </p>
              <button
                v-on:click="modal9 = false"
                class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
              >
                Kembali
              </button>
            </div>
          </b-modal>
          <b-modal
            v-model="modal10"
            size="lg"
            modal-class="border-0"
            header-class="background-primary"
            footer-class="justify-content-center"
            v-bind:centered="true"
            v-bind:hide-footer="true"
          >
            <template slot="modal-header">
              <h4
                class="container text-uppercase text-white font-weight-bold text-center mb-0"
              >
                Fasilitas yang didapatkan:
              </h4>
            </template>
            <div class="container px-5 py-2">
              <p class="font-weight-medium mb-1">
                Fasilitas Kelas 10/11 SMA: <br />
                1. Sesi pertemuan belajar tatap muka/secara daring minimal 4
                sesi/pekan.<br />
                2. Buku kumpulan materi dan ribuan soal-soal latihan
                terlengkap.<br />
                3. Tes evaluasi tiap bab pelajaran untuk mengetahui perkembangan
                siswa.<br />
                4. Tambahan belajar untuk persiapan ujian sekolah.<br />
                5. Tryout untuk persiapan ujian sekolah. 6. Sistem akademik yang
                mencakup laporan hasil belajar, laporan kehadiran, serta materi
                pembelajaran yang dapat diakses 24 jam<br />
                7. Sistem forum tanya jawab pada website yang bisa diakses 24
                jam.<br />
                8. Standby Teacher terjadwal.
              </p>
              <button
                v-on:click="modal10 = false"
                class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
              >
                Kembali
              </button>
            </div>
          </b-modal>
          <b-modal
            v-model="modal12"
            size="lg"
            modal-class="border-0"
            header-class="background-primary"
            footer-class="justify-content-center"
            v-bind:centered="true"
            v-bind:hide-footer="true"
          >
            <template slot="modal-header">
              <h4
                class="container text-uppercase text-white font-weight-bold text-center mb-0"
              >
                Fasilitas yang didapatkan:
              </h4>
            </template>
            <div class="container px-5 py-2">
              <p class="font-weight-medium mb-1">
                Fasilitas Kelas 12 SMA: <br />
                1. Didampingi pembimbing kelas dari lulusan PTN favorit yang
                akan selalu update informasi mengenai jalur masuk PTN.<br />
                2. Buku kumpulan materi dan ribuan soal-soal latihan
                terlengkap.<br />
                3. Tes evaluasi tiap bab materi untuk mengetahui perkembangan
                siswa.<br />
                4. Tryout UTBK rutin terjadwal secara daring dan sistem yang
                terbaru.<br />
                5. Sistem akademik yang mencakup laporan hasil belajar, laporan
                kehadiran, serta materi pembelajaran yang dapat diakses 24
                jam<br />
                6. Sistem forum tanya jawab pada website yang bisa diakses 24
                jam.<br />
                7. Standby Teacher terjadwal.<br />
                8. Layanan Psikotes yang bekerja sama dengan lembaga psikologi
                profesional untuk mengetahui minat dan bakat siswa.<br />
                9. Pertemuan orang tua dengan perwakilan dari berbagai PTN
                favorit untuk update informasi mengenai jalur masuk PTN.<br />
                10. Pertemuan belajar tatap muka/daring terjadwal dengan jadwal
                minimal 3-6 sesi/pekan tergantung dari paket yang dipilih*<br />
                11. Jumlah siswa per kelas sebanyak 10-35 siswa tergantung dari
                paket yang dipilih*.<br /><br />
                * Terdapat paket program Reguler, Khusus, atau Super Khusus
              </p>
              <button
                v-on:click="modal12 = false"
                class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
              >
                Kembali
              </button>
            </div>
          </b-modal>
          <b-modal
            v-model="modalAl"
            size="lg"
            modal-class="border-0"
            header-class="background-primary"
            footer-class="justify-content-center"
            v-bind:centered="true"
            v-bind:hide-footer="true"
          >
            <template slot="modal-header">
              <h4
                class="container text-uppercase text-white font-weight-bold text-center mb-0"
              >
                Fasilitas yang didapatkan:
              </h4>
            </template>
            <div class="container px-5 py-2">
              <p class="font-weight-medium mb-1">
                Fasilitas Kelas Alumni: <br />
                1. Didampingi pembimbing kelas dari lulusan PTN favorit yang
                akan selalu update informasi mengenai jalur masuk PTN.<br />
                2. Buku kumpulan materi dan ribuan soal-soal latihan
                terlengkap.<br />
                3. Tes evaluasi tiap bab materi untuk mengetahui perkembangan
                siswa.<br />
                4. Tryout UTBK rutin terjadwal secara daring dan sistem yang
                terbaru.<br />
                5. Sistem akademik yang mencakup laporan hasil belajar, laporan
                kehadiran, serta materi pembelajaran yang dapat diakses 24
                jam<br />
                6. Sistem forum tanya jawab pada website yang bisa diakses 24
                jam.<br />
                7. Standby Teacher terjadwal.<br />
                8. Layanan Psikotes yang bekerja sama dengan lembaga psikologi
                profesional untuk mengetahui minat dan bakat siswa.<br />
                9. Pertemuan orang tua dengan perwakilan dari berbagai PTN
                favorit untuk update informasi mengenai jalur masuk PTN.<br />
                10. Pertemuan belajar tatap muka/daring terjadwal dengan jadwal
                minimal 6 sesi/pekan.<br />
                11. Jumlah siswa per kelas sebanyak 15-17 siswa.<br /><br />
              </p>
              <button
                v-on:click="modalAl = false"
                class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
              >
                Kembali
              </button>
            </div>
          </b-modal>
        </section>
        <!-- <section> close ============================-->
        <!-- ============================================-->

        <section class="bg-100" id="benefits">
          <div
            class="bg-holder d-none d-md-block"
            style="
              background-image: url(/static/images/page/about/natasya-benefit-resize.png);
              background-position: left bottom;
              background-size: contain;
            "
          ></div>
          <div
            class="bg-holder d-none d-md-block"
            style="
              background-image: url(/static/images/page/about/sistem.png);
              background-position: right bottom;
              background-size: contain;
            "
          ></div>
          <!--/.bg-holder-->

          <div
            class="bg-holder d-block d-md-none"
            style="
              background-image: url(/static/images/page/about/sistem.png);
              background-position: bottom;
              background-size: contain;
            "
          ></div>
          <!--/.bg-holder-->

          <div class="container">
            <div class="row align-items-center min-vh-md-75">
              <div class="col-md-5 col-lg-6 py-6 text-sm-start text-center">
                <!--<p class="mb-5 fs-1 lh-lg">We are always availed to consult on taking your higher education to the next level so you can stay competitive in the global world.</p>-->
                <div class="mt-5 mt-xl-6"></div>
              </div>
              <div class="col-md-7 col-lg-6 py-6 text-sm-start text-center">
                <h1
                  class="mt-6 mb-sm-4 display-4 fw-light lh-sm fs-4 fs-lg-4 fs-xxl-7"
                >
                  Nikmati Keuntungan Sistem
                  <span class="text-primary">E-Learning </span
                  ><br class="d-block d-lg-none d-xl-block" />BTA Group
                </h1>
                <!--<p class="mb-5 fs-1 lh-lg">We are always availed to consult on taking your higher education to the next level so you can stay competitive in the global world.</p>-->
                <div class="mt-5 mt-xl-6"></div>
              </div>
            </div>
          </div>
        </section>

        <!-- ============================================-->
        <!-- <section> begin ============================-->
        <section id="testimonial">
          <div class="container">
            <div class="row">
              <div class="col-lg-7 mx-auto text-center my-5">
                <h5 class="fw-light fs-3 fs-lg-5 lh-sm mb-4">Testimoni</h5>
                <!--<p class="mb-5">Torquem detraxit hosti et quidem faciunt, ut et negent satis esse appetendum, alterum. Si sine causa? quae fuerit causa, mox videro; interea hoc epicurus in liberos.</p>-->
              </div>
            </div>

            <div class="row flex-center h-100">
              <div class="col-xl-9">
                <div
                  class="carousel slide"
                  id="carouselTestimonials"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active" data-bs-interval="10000">
                      <div class="row h-100 justify-content-center">
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi1-21.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Sydney Tjandra
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA K 1 Penabur - Pendidikan Dokter UI 2021
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar tidak terasa beban di BTA - dari
                                pengajar yang gaul, binglas yang sangat cepat
                                tanggap, sampai teman-teman yang ramah, semuanya
                                mendukung suasana belajar yang kondusif dan
                                asik. Semua pengajar BTA terlihat sangat sepenuh
                                hati ingin mengajar, bersedia menjelaskan hingga
                                kita paham, dan bersedia mencari tahu lebih bila
                                ada soal yang belum dapat diselesaikan. Saya
                                juga senang sekali bisa berkenalan dengan
                                teman-teman sefrekuensi di kelas BTA, yang
                                beberapa kini sejurusan denganku. <br />BTA
                                tempat les yang tidak memaksa para muridnya
                                untuk belajar, tetapi aktif dengan menyediakan
                                berbagai fasilitas. BTA Group menyediakan
                                segudang soal dalam buku, tak lupa tryout rutin
                                yang bisa membuat kita mengira-ngira posisi
                                kesiapan kita menuju ujian masuk PTN nantinya.
                                Saya tidak pernah khawatir kekurangan soal.
                                Kalau kamu anak yang proaktif dan memiliki
                                semangat belajar tinggi, pasti banyak yang bisa
                                kamu dapatkan dari belajar di BTA. Semangat
                                teman-teman pejuang PTN!
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi2-21.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Sifa Zahrah
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA GIS JAKARTA <br />F.MIPA ITB 2021
                                    (SBMPTN) <br />Aktuaria UI 2021 (SIMAK
                                    UI)<br />Aktuaria UGM 2021 (UM-UGM)
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar di BTA seru bangett!! Kakak-kakak
                                binglas dan pengajarnya juga ramah-ramah semua,
                                pembelajarannya juga jadi gampang dimengerti.
                                Fitur-fitur di webnya juga membantu bangett buat
                                kita belajar, mulai dari ringkasan yang bisa
                                bantu kita track nilai-nilai tryout, forum buat
                                kita tanya-tanya soal ke pengajar, sampe
                                video-video materi untuk review pembelajaran.
                                Aku merasa terbantu banget dari awal persiapan
                                UTBK sampe persiapan ujian-ujian mandiri. Thank
                                you BTA, semoga sukses terus!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="5000">
                      <div class="row h-100 justify-content-center">
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi3.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Jonathan Abram Dewanto
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA Regina Pacis Jakarta - Ilmu Hukum UGM
                                    2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar di BTA tuh asik banget, gurunya
                                bener-bener ahli di bidangnya dan ga takut kalo
                                ditanyain dalem-dalem tentang suatu materi.
                                Karena itu aku bisa bener-bener ngerti materi
                                yang diajarin dan ga perlu ngafalin lagi
                                jadinya. Apa yang dikasih di BTA, selain bantuin
                                aku masuk ke FH UGM, IUP FH UGM, dan FH KKI UI,
                                juga bantuin aku untuk semakin kritis di kampus.
                                Keren banget deh BTA
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi4.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Neysa Ardelia Fitriani
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA N 77 JAKARTA - Ilmu Komunikasi UNDIP
                                    2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar di BTA asik bgt meskipun perjalanan yg
                                aku tempuh dr rmh ke BTA lumayan jauh tp ga
                                bikin aku males buat dtg les ataupun tambahan,
                                kaka pengajarnya msh pada muda-muda jdnya
                                ngajarnya ga bikin ngantuk trus materi-materi yg
                                dikasih BTA benar-benar berguna buat sbmptn dan
                                mandiri
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="3000">
                      <div class="row h-100 justify-content-center">
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi5.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Fresty Tania Stearine
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA N 8 Jakarta - FTSL ITB 2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                BTA merupakan salah satu penunjang semangat
                                belajarku yang paling penting! Di sini
                                kakak-kakaknya asik, ramah, dan suportif.
                                Fasilitas seperti try out dan pembahasan melalui
                                website (ini keren dan bagus banget!), kelas
                                stand by, dan soal-soal yang menantang menjadi
                                nilai plus banget untuk BTA. Variasi soalnya
                                sangat banyak, tetapi gak asal-asalan!
                                Benar-benar setipe dan HOTS seperti tahun
                                sebelumnya. Lingkungan belajarnya santai, tetapi
                                tetap kondusif untuk belajar giat. Walaupun
                                beberapa minggu harus PJJ, belajar di BTA tetap
                                gencar banget, gak kendor sama sekali. Asik,
                                deh, pokoknya!
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi6-rev.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Martin Aurelius
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA Kemurnian 2 - Pendidikan Dokter UI 2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar di BTA, aku terfasilitasi banget belajar
                                UTBK sampai ujian mandiri. Aku sering tanya ke
                                gurunya tentang materi dan dijelasin sampe
                                ngerti. Materi dari BTA juga relevan banget. Aku
                                juga seneng banget sama TO yang rutin, jadi tau
                                sampai mana progres belajar kita. Binglasnya
                                juga baik dan informatif banget, selalu ngasih
                                tau info info ter-update tentang PTN.
                                Pembelajaran onlinenya juga keren banget,
                                kelasnya asik, banyak video di website yang
                                menurut aku ngebantu banget buat memahami materi
                                yang belom aku kuasain. Pokoknya BTA keren
                                banget!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="row h-100 justify-content-center">
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi7.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Saraswati Widuri
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMAN 12 Jakarta - Ilmu Kesejahteraan Sosial
                                    Unpad 2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                Belajar di BTA enjoy banget asli.. selain
                                tempatnya nyaman dan fasilitas yang memadai,
                                cara penyampaian materinya juga enak karena
                                pengajarnya asik, jadi materi yang disampaikan
                                berasa lebih mudah buat masuk ke otak hehe..
                                Terus kita ada binglas (pembimbing kelas) yg
                                informatif, jadi kita nggak ketinggalan info
                                penting mengenai PTN. Selain itu ada tes minat
                                bakat yang ngebantu buat nentuin jurusan di
                                perkuliahan. Nggak kalah penting itu latihan
                                soal dan TO nya ngebantu banget karena dari yang
                                kurasain, soal dan TO BTA lebih susah dari UTBK.
                                Biarpun tahun ini sempat belajar online buat
                                persiapan UTBK gara-gara pandemi, tapi sama kok
                                cara penyampaian materinya dan tetap ngebantu
                                buat persiapan UTBK karena suka diajarin tips
                                biar cepat jawab soal.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-4">
                          <div class="card h-100 shadow card-span p-3">
                            <div class="card-body">
                              <div class="d-flex align-items-center">
                                <img
                                  class="img-fluid"
                                  src="/static/images/page/about/testi8.png"
                                  alt="testimonials"
                                />
                                <div class="flex-1 ms-4">
                                  <h6 class="fw-light fs-lg-1 mb-1">
                                    Valerie Prasetya
                                  </h6>
                                  <p class="fw-normal mb-0 text-800">
                                    SMA Pahoa - Ilmu HI UGM 2020
                                  </p>
                                </div>
                              </div>
                              <p class="mb-0 mt-4 fw-light lh-lg">
                                BTA menurutku adalah pilihan tepat untuk
                                persiapan PTN. Pengajarnya seru dan sangat
                                berpengalaman. Ga cuma sharing tentang
                                pelajaran, tapi mereka juga sharing tentang
                                SBMPTN, kuliah, jurusan. BTA pun punya binglas
                                semacam wali kelas di sekolah. Selain
                                menyampaikan info penting seputar PTN, kita juga
                                bisa konsultasi jurusan ke mereka. Meskipun
                                banyak kebijakan berubah akibat Covid-19, BTA
                                selalu siap dan gesit mengubah sistem
                                pembelajaran. Peralihan pembelajaran dari
                                offline ke online pun berjalan dengan cepat dan
                                nggak ada yang berubah dari segi kepadatan
                                pemberian materi. Web BTA juga dikemas dengan
                                ciamik sebagai platform belajar yang efektif.
                                Sistem Tryout nya akurat dan rapi interfacenya.
                                Jadi kemarin aku belajar setiap hari untuk UTBK,
                                nggak bakal ada yang namanya kehabisan materi
                                untuk dipelajari karena ada juga video streaming
                                juga yang diposting di web BTA. Overall BTA
                                worth it banget dan aku nggak nyesel ikut les di
                                sini.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5 flex-center">
                    <div class="col-auto position-relative z-index-2">
                      <ol class="carousel-indicators">
                        <li
                          class="active mx-2"
                          data-bs-target="#carouselTestimonials"
                          data-bs-slide-to="0"
                        ></li>
                        <li
                          class="mx-2"
                          data-bs-target="#carouselTestimonials"
                          data-bs-slide-to="1"
                        ></li>
                        <li
                          class="mx-2"
                          data-bs-target="#carouselTestimonials"
                          data-bs-slide-to="2"
                        ></li>
                        <li
                          class="mx-2"
                          data-bs-target="#carouselTestimonials"
                          data-bs-slide-to="3"
                        ></li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of .container-->
        </section>
        <!-- <section> close ============================-->
        <!-- ============================================-->

        <!-- ============================================-->
        <!-- <section> begin ============================-->
        <section class="py-6 bg-100">
          <div class="container">
            <div class="row flex-center">
              <div class="col-md-7 col-lg-6 offset-xl-1">
                <h1 class="fw-light text-center text-md-start fs-lg-3 fs-xl-4">
                  Siap untuk menggapai cita-citamu?
                </h1>
              </div>
              <div class="col-md-4 text-center text-lg-end">
                <a class="btn btn-lg btn-primary hover-top" href="#home"
                  >Daftar Sekarang
                  <svg
                    class="bi bi-arrow-right-short ms-2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  ></svg
                ></a>
              </div>
            </div>
          </div>
          <!-- end of .container-->
          <div class="row">
            <div class="col text-center mt-5">
              <Adsense
                v-bind:data-ad-client="googleAdsClientKey"
                data-ad-slot="6426122373"
              ></Adsense>
            </div>
          </div>
        </section>
        <!-- <section> close ============================-->
        <!-- ============================================-->
      </main>
      <!-- ===============================================-->
      <!--    End of Main Content-->
      <!-- ===============================================-->

      <!-- ===============================================-->
      <!--    JavaScripts-->
      <!-- ===============================================-->
      <script type="application/javascript" src="vendors/@popperjs/popper.min.js"></script>
      <script type="application/javascript" src="vendors/bootstrap/bootstrap.min.js"></script>
      <script type="application/javascript" src="vendors/is/is.min.js"></script>
      <script type="application/javascript" src="assets/js/theme.js"></script>

      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&amp;display=swap"
        rel="stylesheet"
      />
      <script type="application/javascript" src="assets/js/jquery.min.js"></script>
		<!-- <script
        type="text/javascript"
        src="{{ asset('/bootstrap.min.js') }}"
      ></script> -->
      <script type="application/javascript" src="assets/js/bootstrap-navbar.js"></script>
      <script type="application/javascript" src="assets/js/detector.js"></script>
      <script type="application/javascript" src="assets/js/scroll-to-top.js"></script>
      <script type="application/javascript" src="assets/js/theme.js"></script>
      <script type="application/javascript" src="assets/js/theme.min.js"></script>
      <script type="application/javascript" src="assets/js/utils.js"></script>
    </body>
  </html>
</template>

<script type="application/javascript">
export default {
  name: "Index",

  data: function () {
    return {
      gambarHomes: [
        {
          image: "https://imgur.com/IXfwwtD",
        },
      ],
	  popup: true,
      modal9: false,
      modal10: false,
      modal12: false,
      modalAl: false,
      testimonials: [
        {
          image: "https://i.imgur.com/XWui7XC.jpg",
          people: "Ghina Ramadhanti",
          occupation: "SMA 8/FKUI 2016",
          content:
            "Halo BTA Group! Wah, seru banget sih belajar di BTA. Gak kerasa gitu waktunya dan gak jadi beban karena bareng sama teman-teman dan kakak-kakak yang seru juga. Kakak-kakaknya sabar pas ngajarin, suka ngasih fun facts yang bikin belajar menjadi suatu hal yang menyenangkan. Terus, tambahannya bisa kapan aja dan bisa request guru. Pokoknya sebaik dan sengebantu itu deh BTA dalam mewujudkan mimpi. Makasih BTA!",
        },
        {
          image: "https://i.imgur.com/zXsEnHE.jpg",
          people: "Nicolas Barnas",
          occupation: "SMA Kanisius/ Teknik Kimia UI & UGM 2017",
          content:
            "Satu kata yang merepresentasikan BTA adalah membimbing. Para pengajar benar-benar dikenal, bersahabat & mampu mengajarkan siswa dengan efektif. BTA sangat membantu saya menghadapi SBMPTN dengan baik & hasilnya memuaskan. Saya bertemu banyak teman baru, tahu banyak tips & trik masuk PTN dan tentunya siap menghadapi SBMPTN dan tes PTN lainnya. Terima kasih atas bimbingan guru dan kakak-kakak binglas! BTA recommended!",
        },
        {
          image: "https://i.imgur.com/eBjYO7z.jpg",
          people: "Stevenlie August",
          occupation: "SMAK 1 Penabur/ FTI ITB 2017",
          content:
            "BTA itu keren banget. Kakak-kakak pengajarnya seru dan pinter. Mereka pun tahu banget tips dan trik SBMPTN. Sistem di BTA teratur, suasananya nyaman dan yang jelas ngebantu buat SBMPTN. BTA asik banget lah pokoknya. Thankyou BTA!",
        },
        {
          image: "https://i.imgur.com/QutmQLI.jpg",
          people: "Tiara Permatasari",
          occupation: "SMA 12/SBM ITB 2016",
          content:
            "Danke schon BTA! Makasih banyak ya BTA, makasih buat kakak-kakak binglas & kakak-kakak yg udah ngajarin & ngebantu aku selama setahun ini. Gak percuma setiap hari Minggu belajar di BTA, ikut intensif setiap hari dari BTA, aku akhirnya lolos jalur SBMPTN dan keterima di pilihan pertama aku SBM ITB",
        },
        {
          image: "https://i.imgur.com/Uygncfm.jpg",
          people: "Maura Finessa",
          occupation: "Santa Ursula/Akuntansi UGM 2016",
          content:
            "Belajar di BTA tuh bener-bener kondusif banget ditambah lagi pengajar-pengajarnya yang super jago dan super asik! Tips dan trik yang dikasih kakak2 pengajar juga sangat membantu dalam mengerjakan SBMPTN! Kelas tambahan yang dibuat per mata pelajaran juga bener2 membantu aku buat fokus terhadap bidang ilmu yang aku kurang paham dan mendalami ilmu yang aku sudah lumayan paham. Terima kasih BTA, berkat kalian aku berhasil diterima di Akuntansi UGM lewat jalur SBMPTN:).",
        },
      ],
      googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
      primaryBranches: [],
    };
  },

// ============================================================
// AWAL SCRIPT BARU POP UP TO
// ============================================================
methods: {
  getWaNumber(branch) {
      if (!branch.address) return '';
      const match = branch.address.match(/\b(?:wa|whatsapp|whats\s*app|whatsap|watsap)\b[\s\S]*?((?:0|62)8[\d\-\s+]{6,})/i);
      if (match) {
          let phone = match[1].replace(/\D/g, '');
          return phone.startsWith('0') ? '62' + phone.substring(1) : phone;
      }
      if (branch.isPrimary) {
          const fallbackMatch = branch.address.match(/(?:62|0)8\d{8,11}/);
          if (fallbackMatch) {
              let phone = fallbackMatch[0].replace(/\D/g, '');
              return phone.startsWith('0') ? '62' + phone.substring(1) : phone;
          }
      }
      return '';
  },
  getWaLink(branch) {
      const phone = this.getWaNumber(branch);
      if (!phone) return null;
      const text = encodeURIComponent(`Halo, boleh tanya mengenai Program Bimbingan di ${branch.name}?`);
      return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
  },
  fetchBranchData() {
      this.axios.get(process.env.API_URL + '/branch', {params: {isHidden: false}}).then(response => {
          var data = response.data.data;
          this.primaryBranches = data.filter(branch => {
              return branch.isPrimary;
          });
      });
  },
  checkLoginAndGo() {
    const isUserLoggedIn = this.$store.getters.isAuthenticated;
    const profile = this.$store.state.profile;

    const getTargetLink = (gradeId) => {
      // const gId = parseInt(gradeId);
      // if (gId === 13) return "/account/student/tryout/1354"; // Kelas 8
      // if (gId === 1) return "/account/student/tryout/1361";  // Kelas 9
      // if ([2, 4, 5, 6, 7, 8, 9, 57].includes(gId)) return "/account/student/tryout/1362"; // SMA & UTBK
      return "/account/student/score";
    };

    if (isUserLoggedIn && profile && profile.student) {
      const student = profile.student;
      
      // ini yg baru: pakai gaya klasik tanpa tanda tanya (?.), kompatibel dengan Node.js v8
      const gradeId = (student && student.btaGradeID) || 
                      (student && student.btaGrade && student.btaGrade.id) || 
                      (student && student.gradeID);

      if (gradeId) {
        window.location.href = getTargetLink(gradeId);
      } else { // ini yg baru
        window.location.href = "/account/student/score"; // ini yg baru
      }
    } else {

      localStorage.setItem('redirectAfterLogin', 'PENDING_SPECIFIC_LINK');
      
      this.popup = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        alert("Kamu belum login. Masuk dulu untuk lanjut ??");
      }, 800);
    }
  }
},
// ============================================================
// AKHIR SCRIPT BARU POP UP TO
// ============================================================

  created() {
	
    this.fetchBranchData();

    this.axios
      .all([
        this.axios.get(process.env.API_URL + "/article/most-recent"),
        this.axios.get(process.env.API_URL + "/article", {
          params: { limit: this.articleLimit, skip: 1 },
        }),
      ])
      .then(
        this.axios.spread(
          function (responseRecentArticle, responseArticles) {
            this.recentArticle = responseRecentArticle.data.data;
            this.articles = responseArticles.data.data.data;
          }.bind(this)
        )
      );
  },
  mounted() {
	
    document.title =
      "Bimbingan Belajar Offline/Online Terbaik No 1 Di Indonesia " +
      process.env.APP_NAME;
    let carouselScript = document.createElement("script");
    carouselScript.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/js/bootstrap.bundle.min.js"
    );
    document.head.appendChild(carouselScript);
  },

};



</script>

<style scoped>
/* !
 * Bootstrap v5.0.0-alpha1 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE) */

:root {
  --bs-blue: #717cff;
  --bs-indigo: #53acf8;
  --bs-purple: #ad71ff;
  --bs-pink: #ff71c3;
  --bs-red: #ff717c;
  --bs-orange: #ff8125;
  --bs-yellow: #ffee25;
  --bs-green: #5fa500;
  --bs-teal: #00a598;
  --bs-cyan: #3eb8f4;
  --bs-white: #fff;
  --bs-gray: #c3bcc4;
  --bs-gray-dark: #b0a7b2;
  --bs-primary: #717cff;
  --bs-secondary: #a79ca8;
  --bs-success: #5fa500;
  --bs-info: #3eb8f4;
  --bs-warning: #ffee25;
  --bs-danger: #ff717c;
  --bs-light: #f9fafd;
  --bs-dark: #44224b;
  --bs-font-sans-serif: "Poppins", "Open Sans", -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --bs-font-monospace: "SFMono-Regular", Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.15),
    rgba(255, 255, 255, 0)
  );
}

*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}




hr {
  margin: 1rem 0;
  color: #dfdbdf;
  background-color: currentColor;
  border: 0;
  opacity: 1;
}

hr:not([size]) {
  height: 1px;
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 500;
  line-height: 1.2;
  color: #091e40;
}

h1,
.h1 {
  font-size: calc(1.37383rem + 1.48598vw);
}

@media (min-width: 1200px) {
  h1,
  .h1 {
    font-size: 2.48832rem;
  }
}

h2,
.h2 {
  font-size: calc(1.33236rem + 0.98832vw);
}

@media (min-width: 1200px) {
  h2,
  .h2 {
    font-size: 2.0736rem;
  }
}

h3,
.h3 {
  font-size: calc(1.2978rem + 0.5736vw);
}

@media (min-width: 1200px) {
  h3,
  .h3 {
    font-size: 1.728rem;
  }
}

h4,
.h4 {
  font-size: calc(1.269rem + 0.228vw);
}

@media (min-width: 1200px) {
  h4,
  .h4 {
    font-size: 1.44rem;
  }
}

h5,
.h5 {
  font-size: 1.2rem;
}

h6,
.h6 {
  font-size: 0.83333rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 800;
}

small,
.small {
  font-size: 75%;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #717cff;
  text-decoration: none;
}

a:hover {
  color: #016b9d;
  text-decoration: underline;
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 75%;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 75%;
  color: #ff71c3;
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 75%;
  color: #fff;
  background-color: #a79ca8;
  border-radius: 0.625rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #ccc6cd;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.2rem;
  font-weight: 400;
}

.display-1 {
  font-size: calc(1.55498rem + 3.65978vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 4.29982rem;
  }
}

.display-2 {
  font-size: calc(1.48332rem + 2.79982vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 3.58318rem;
  }
}

.display-3 {
  font-size: calc(1.4236rem + 2.08318vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 2.98598rem;
  }
}

.display-4 {
  font-size: calc(1.37383rem + 1.48598vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 2.48832rem;
  }
}

.display-5 {
  font-size: calc(1.33236rem + 0.98832vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 2.0736rem;
  }
}

.display-6 {
  font-size: calc(1.2978rem + 0.5736vw);
  font-weight: 900;
  line-height: 1;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 1.728rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 75%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 75%;
  color: #c3bcc4;
}

.blockquote-footer::before {
  content: "\2014\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dfdbdf;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 75%;
  color: #c3bcc4;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 1rem);
  padding-left: var(--bs-gutter-x, 1rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
  }
}

@media (min-width: 1540px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl,
  .container-xxl {
    max-width: 1480px;
  }
}

.row {
  --bs-gutter-x: 2rem;
  --bs-gutter-y: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) / -2);
  margin-left: calc(var(--bs-gutter-x) / -2);
}

.row > * {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) / 2);
  padding-left: calc(var(--bs-gutter-x) / 2);
  margin-top: var(--bs-gutter-y);
}

.col {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
}

.row-cols-auto > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 33.33333%;
}

.row-cols-4 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 16.66667%;
}

.col-auto {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 8.33333%;
}

.col-2 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 16.66667%;
}

.col-3 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 33.33333%;
}

.col-5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 41.66667%;
}

.col-6 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 58.33333%;
}

.col-8 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 66.66667%;
}

.col-9 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 83.33333%;
}

.col-11 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 91.66667%;
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.8rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.8rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 4rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 4rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 5rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 5rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 7.5rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 7.5rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 10rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 10rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 12.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 12.5rem;
}

.g-11,
.gx-11 {
  --bs-gutter-x: 15rem;
}

.g-11,
.gy-11 {
  --bs-gutter-y: 15rem;
}

@media (min-width: 576px) {
  .col-sm {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 576px) {
  .row-cols-sm-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 576px) {
  .col-sm-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 576px) {
  .col-sm-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 576px) {
  .col-sm-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 576px) {
  .col-sm-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 576px) {
  .col-sm-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 576px) {
  .col-sm-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 576px) {
  .offset-sm-0 {
    margin-left: 0;
  }
}

@media (min-width: 576px) {
  .offset-sm-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-3 {
    margin-left: 25%;
  }
}

@media (min-width: 576px) {
  .offset-sm-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-6 {
    margin-left: 50%;
  }
}

@media (min-width: 576px) {
  .offset-sm-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 576px) {
  .offset-sm-9 {
    margin-left: 75%;
  }
}

@media (min-width: 576px) {
  .offset-sm-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 576px) {
  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 576px) {
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 576px) {
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 576px) {
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 576px) {
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 576px) {
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 576px) {
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 576px) {
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 576px) {
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 576px) {
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 576px) {
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 576px) {
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 576px) {
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 576px) {
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 576px) {
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 576px) {
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 576px) {
  .g-sm-11,
  .gx-sm-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 576px) {
  .g-sm-11,
  .gy-sm-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 768px) {
  .row-cols-md-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 768px) {
  .row-cols-md-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 768px) {
  .col-md-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 768px) {
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 768px) {
  .col-md-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 768px) {
  .col-md-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 768px) {
  .col-md-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .offset-md-0 {
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .offset-md-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-3 {
    margin-left: 25%;
  }
}

@media (min-width: 768px) {
  .offset-md-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-6 {
    margin-left: 50%;
  }
}

@media (min-width: 768px) {
  .offset-md-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 768px) {
  .offset-md-9 {
    margin-left: 75%;
  }
}

@media (min-width: 768px) {
  .offset-md-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 768px) {
  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 768px) {
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 768px) {
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 768px) {
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 768px) {
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 768px) {
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 768px) {
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 768px) {
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 768px) {
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 768px) {
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 768px) {
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 768px) {
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 768px) {
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 768px) {
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 768px) {
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 768px) {
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 768px) {
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 768px) {
  .g-md-11,
  .gx-md-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 768px) {
  .g-md-11,
  .gy-md-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 992px) {
  .row-cols-lg-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 992px) {
  .col-lg-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 992px) {
  .col-lg-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 992px) {
  .col-lg-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 992px) {
  .col-lg-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 992px) {
  .col-lg-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .offset-lg-0 {
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  .offset-lg-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-3 {
    margin-left: 25%;
  }
}

@media (min-width: 992px) {
  .offset-lg-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-6 {
    margin-left: 50%;
  }
}

@media (min-width: 992px) {
  .offset-lg-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 992px) {
  .offset-lg-9 {
    margin-left: 75%;
  }
}

@media (min-width: 992px) {
  .offset-lg-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 992px) {
  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 992px) {
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 992px) {
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 992px) {
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 992px) {
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 992px) {
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 992px) {
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 992px) {
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 992px) {
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 992px) {
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 992px) {
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 992px) {
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 992px) {
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 992px) {
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 992px) {
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 992px) {
  .g-lg-11,
  .gx-lg-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 992px) {
  .g-lg-11,
  .gy-lg-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 1200px) {
  .row-cols-xl-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1200px) {
  .col-xl-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1200px) {
  .col-xl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1200px) {
  .col-xl-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 1200px) {
  .col-xl-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 1200px) {
  .col-xl-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-0 {
    margin-left: 0;
  }
}

@media (min-width: 1200px) {
  .offset-xl-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-3 {
    margin-left: 25%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-6 {
    margin-left: 50%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-9 {
    margin-left: 75%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 1200px) {
  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 1200px) {
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 1200px) {
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-11,
  .gx-xl-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 1200px) {
  .g-xl-11,
  .gy-xl-11 {
    --bs-gutter-y: 15rem;
  }
}

@media (min-width: 1540px) {
  .col-xxl {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-auto > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-1 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-2 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-3 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-4 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-5 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 20%;
  }
}

@media (min-width: 1540px) {
  .row-cols-xxl-6 > * {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
  }
}

@media (min-width: 1540px) {
  .col-xxl-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 8.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 41.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 58.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 66.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 83.33333%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 91.66667%;
  }
}

@media (min-width: 1540px) {
  .col-xxl-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-0 {
    margin-left: 0;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-1 {
    margin-left: 8.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-2 {
    margin-left: 16.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-3 {
    margin-left: 25%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-4 {
    margin-left: 33.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-5 {
    margin-left: 41.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-6 {
    margin-left: 50%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-7 {
    margin-left: 58.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-8 {
    margin-left: 66.66667%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-9 {
    margin-left: 75%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-10 {
    margin-left: 83.33333%;
  }
}

@media (min-width: 1540px) {
  .offset-xxl-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1540px) {
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
}

@media (min-width: 1540px) {
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
}

@media (min-width: 1540px) {
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.8rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.8rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 4rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 4rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 7.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 7.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 10rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 10rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 12.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 12.5rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-11,
  .gx-xxl-11 {
    --bs-gutter-x: 15rem;
  }
}

@media (min-width: 1540px) {
  .g-xxl-11,
  .gy-xxl-11 {
    --bs-gutter-y: 15rem;
  }
}

.table {
  --bs-table-bg: rgba(0, 0, 0, 0);
  --bs-table-striped-color: #778295;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #778295;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #778295;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: #778295;
  vertical-align: top;
  border-color: #dfdbdf;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  -webkit-box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table > :not(:last-child) > :last-child > * {
  border-bottom-color: currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: #e3e5ff;
  --bs-table-striped-bg: #d8daf2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cccee6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d2d4ec;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #cccee6;
}

.table-secondary {
  --bs-table-bg: #edebee;
  --bs-table-striped-bg: #e1dfe2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #d5d4d6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #dbd9dc;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #d5d4d6;
}

.table-success {
  --bs-table-bg: #dfedcc;
  --bs-table-striped-bg: #d4e1c2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c9d5b8;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #cedbbd;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #c9d5b8;
}

.table-info {
  --bs-table-bg: #d8f1fd;
  --bs-table-striped-bg: #cde5f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c2d9e4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c8dfea;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #c2d9e4;
}

.table-warning {
  --bs-table-bg: #fffcd3;
  --bs-table-striped-bg: #fbf8d1;
  --bs-table-striped-color: #b0a7b2;
  --bs-table-active-bg: #f7f4d0;
  --bs-table-active-color: #b0a7b2;
  --bs-table-hover-bg: #f9f6d1;
  --bs-table-hover-color: #b0a7b2;
  color: #b0a7b2;
  border-color: #f7f4d0;
}

.table-danger {
  --bs-table-bg: #ffe3e5;
  --bs-table-striped-bg: #f2d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6ccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ecd2d4;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #e6ccce;
}

.table-light {
  --bs-table-bg: #f9fafd;
  --bs-table-striped-bg: #f5f6f9;
  --bs-table-striped-color: #b0a7b2;
  --bs-table-active-bg: #f2f2f6;
  --bs-table-active-color: #b0a7b2;
  --bs-table-hover-bg: #f4f4f7;
  --bs-table-hover-color: #b0a7b2;
  color: #b0a7b2;
  border-color: #f2f2f6;
}

.table-dark {
  --bs-table-bg: #44224b;
  --bs-table-striped-bg: #4d2d54;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #57385d;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #523359;
  --bs-table-hover-color: #fff;
  color: #fff;
  border-color: #57385d;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1539.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1rem;
}

.col-form-label-sm {
  padding-top: calc(0.1rem + 1px);
  padding-bottom: calc(0.1rem + 1px);
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 75%;
  color: #ccc6cd;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #f1f2ff;
  background-clip: padding-box;
  border: 1px solid #d5d1d6;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-control[type="file"] {
  overflow: hidden;
}

.form-control[type="file"]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: #778295;
  background-color: #f1f2ff;
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}

.form-control::-webkit-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::-moz-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::-ms-input-placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control::placeholder {
  color: #aab0ff !important;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e8e5e9;
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.5rem 1.8rem;
  margin: -0.5rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
  color: #778295;
  background-color: #e8e5e9;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #dcdadd;
}

.form-control::-webkit-file-upload-button {
  padding: 0.5rem 1.8rem;
  margin: -0.5rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
  color: #778295;
  background-color: #e8e5e9;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #dcdadd;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #778295;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.2rem + 2px);
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.form-control-sm::file-selector-button {
  padding: 0.1rem 0.5rem;
  margin: -0.1rem -0.5rem;
  -webkit-margin-end: 0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-sm::-webkit-file-upload-button {
  padding: 0.1rem 0.5rem;
  margin: -0.1rem -0.5rem;
  -webkit-margin-end: 0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 1.25rem;
}

.form-control-lg::file-selector-button {
  padding: 0.7rem 1.8rem;
  margin: -0.7rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
}

.form-control-lg::-webkit-file-upload-button {
  padding: 0.7rem 1.8rem;
  margin: -0.7rem -1.8rem;
  -webkit-margin-end: 1.8rem;
  margin-inline-end: 1.8rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.2rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
}

.form-control-color {
  max-width: 3rem;
  height: auto;
  padding: 0.5rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 5.4rem 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  background-color: #f1f2ff;
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right 1.8rem center;
  background-size: 16px 12px;
  border: 1px solid #d5d1d6;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-select:focus {
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 1.8rem;
  background-image: none;
}

.form-select:disabled {
  background-color: #e8e5e9;
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #778295;
}

.form-select-sm {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.8rem;
  font-size: 1rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #f1f2ff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.25em;
}

.form-check-input[type="radio"] {
  border-radius: 50%;
}

.form-check-input:active {
  -webkit-filter: brightness(90%);
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #b8beff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-check-input:checked {
  background-color: #717cff;
  border-color: #717cff;
}

.form-check-input:checked[type="checkbox"] {
  background-image: url([svg]);
}

.form-check-input:checked[type="radio"] {
  background-image: url([svg]);
}

.form-check-input[type="checkbox"]:indeterminate {
  background-color: #717cff;
  border-color: #717cff;
  background-image: url([svg]);
}

.form-check-input:disabled {
  pointer-events: none;
  -webkit-filter: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label,
.form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url([svg]);
  background-position: left center;
  border-radius: 2em;
  -webkit-transition: background-position 0.15s ease-in-out;
  -o-transition: background-position 0.15s ease-in-out;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  background-image: url([svg]);
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url([svg]);
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn,
.btn-check:disabled + .btn {
  pointer-events: none;
  -webkit-filter: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #717cff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: #d4d8ff;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dfdbdf;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #717cff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  -moz-appearance: none;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: #d4d8ff;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dfdbdf;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: #ccc6cd;
}

.form-range:disabled::-moz-range-thumb {
  background-color: #ccc6cd;
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  padding: 1rem 1.8rem;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 1.8rem;
  pointer-events: none;
  border: 1px solid transparent;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transition: opacity 0.1s ease-in-out,
    -webkit-transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, -webkit-transform 0.1s ease-in-out;
  -o-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out,
    -webkit-transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-floating > .form-control::-webkit-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::-moz-placeholder {
  color: transparent;
}

.form-floating > .form-control:-ms-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::-ms-input-placeholder {
  color: transparent;
}

.form-floating > .form-control::placeholder {
  color: transparent;
}

.form-floating > .form-control:not(:-moz-placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:not(:-ms-input-placeholder) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:not(:-ms-input-placeholder) ~ label {
  opacity: 0.65;
  -ms-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  -ms-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  -webkit-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #778295;
  text-align: center;
  white-space: nowrap;
  background-color: #e8e5e9;
  border: 1px solid #d5d1d6;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 1.25rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 7.2rem;
}

.input-group:not(.has-validation)
  > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation
  > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group
  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 75%;
  color: #5fa500;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(95, 165, 0, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #5fa500;
  padding-right: calc(1.5em + 1rem);
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: #5fa500;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: #5fa500;
  padding-right: 9.9rem;
  background-image: url([svg]), url([svg]);
  background-position: right 1.8rem center, center right 5.4rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
  border-color: #5fa500;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: #5fa500;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: #5fa500;
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
  -webkit-box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(95, 165, 0, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
  color: #5fa500;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid,
.input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 75%;
  color: #ff717c;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(255, 113, 124, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #ff717c;
  padding-right: calc(1.5em + 1rem);
  background-image: url([svg]);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #ff717c;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
  border-color: #ff717c;
  padding-right: 9.9rem;
  background-image: url([svg]), url([svg]);
  background-position: right 1.8rem center, center right 5.4rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  border-color: #ff717c;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
  border-color: #ff717c;
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
  background-color: #ff717c;
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
  -webkit-box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(255, 113, 124, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label,
.form-check-input.is-invalid ~ .form-check-label {
  color: #ff717c;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid,
.input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 500;
  line-height: 1.5;
  color: #778295;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.5rem 1.8rem;
  font-size: 1rem;
  border-radius: 0.313rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.btn:hover {
  color: #778295;
  text-decoration: none;
}

.btn-check:focus + .btn,
.btn:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #ff0126;
  border-color: #ff0126;
}

.btn-primary:hover {
  color: #fff;
  background-color: #016b9d;
  border-color: #016b9d;
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
  color: #fff;
  background-color: #6069d9;
  border-color: #5a63cc;
  -webkit-box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
}

.btn-check:checked + .btn-primary,
.btn-check:active + .btn-primary,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #5a63cc;
  border-color: #555dbf;
}

.btn-check:checked + .btn-primary:focus,
.btn-check:active + .btn-primary:focus,
.btn-primary:active:focus,
.btn-primary.active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(134, 144, 255, 0.5);
}

.btn-primary:disabled,
.btn-primary.disabled {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-secondary {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #8e858f;
  border-color: #867d86;
}

.btn-check:focus + .btn-secondary,
.btn-secondary:focus {
  color: #fff;
  background-color: #8e858f;
  border-color: #867d86;
  -webkit-box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
  box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
}

.btn-check:checked + .btn-secondary,
.btn-check:active + .btn-secondary,
.btn-secondary:active,
.btn-secondary.active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #867d86;
  border-color: #7d757e;
}

.btn-check:checked + .btn-secondary:focus,
.btn-check:active + .btn-secondary:focus,
.btn-secondary:active:focus,
.btn-secondary.active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
  box-shadow: 0 0 0 0 rgba(180, 171, 181, 0.5);
}

.btn-secondary:disabled,
.btn-secondary.disabled {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-success {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-success:hover {
  color: #fff;
  background-color: #518c00;
  border-color: #4c8400;
}

.btn-check:focus + .btn-success,
.btn-success:focus {
  color: #fff;
  background-color: #518c00;
  border-color: #4c8400;
  -webkit-box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
  box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
}

.btn-check:checked + .btn-success,
.btn-check:active + .btn-success,
.btn-success:active,
.btn-success.active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #4c8400;
  border-color: #477c00;
}

.btn-check:checked + .btn-success:focus,
.btn-check:active + .btn-success:focus,
.btn-success:active:focus,
.btn-success.active:focus,
.show > .btn-success.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
  box-shadow: 0 0 0 0 rgba(119, 179, 38, 0.5);
}

.btn-success:disabled,
.btn-success.disabled {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-info {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-info:hover {
  color: #fff;
  background-color: #359ccf;
  border-color: #3293c3;
}

.btn-check:focus + .btn-info,
.btn-info:focus {
  color: #fff;
  background-color: #359ccf;
  border-color: #3293c3;
  -webkit-box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
  box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
}

.btn-check:checked + .btn-info,
.btn-check:active + .btn-info,
.btn-info:active,
.btn-info.active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #3293c3;
  border-color: #2f8ab7;
}

.btn-check:checked + .btn-info:focus,
.btn-check:active + .btn-info:focus,
.btn-info:active:focus,
.btn-info.active:focus,
.show > .btn-info.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
  box-shadow: 0 0 0 0 rgba(91, 195, 246, 0.5);
}

.btn-info:disabled,
.btn-info.disabled {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-warning {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-warning:hover {
  color: #000;
  background-color: #fff146;
  border-color: #fff03b;
}

.btn-check:focus + .btn-warning,
.btn-warning:focus {
  color: #000;
  background-color: #fff146;
  border-color: #fff03b;
  -webkit-box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
  box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
}

.btn-check:checked + .btn-warning,
.btn-check:active + .btn-warning,
.btn-warning:active,
.btn-warning.active,
.show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: #fff151;
  border-color: #fff03b;
}

.btn-check:checked + .btn-warning:focus,
.btn-check:active + .btn-warning:focus,
.btn-warning:active:focus,
.btn-warning.active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
  box-shadow: 0 0 0 0 rgba(217, 202, 31, 0.5);
}

.btn-warning:disabled,
.btn-warning.disabled {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-danger {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-danger:hover {
  color: #fff;
  background-color: #d96069;
  border-color: #cc5a63;
}

.btn-check:focus + .btn-danger,
.btn-danger:focus {
  color: #fff;
  background-color: #d96069;
  border-color: #cc5a63;
  -webkit-box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
}

.btn-check:checked + .btn-danger,
.btn-check:active + .btn-danger,
.btn-danger:active,
.btn-danger.active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #cc5a63;
  border-color: #bf555d;
}

.btn-check:checked + .btn-danger:focus,
.btn-check:active + .btn-danger:focus,
.btn-danger:active:focus,
.btn-danger.active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 134, 144, 0.5);
}

.btn-danger:disabled,
.btn-danger.disabled {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-light {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-light:hover {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
}

.btn-check:focus + .btn-light,
.btn-light:focus {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
  -webkit-box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
  box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
}

.btn-check:checked + .btn-light,
.btn-check:active + .btn-light,
.btn-light:active,
.btn-light.active,
.show > .btn-light.dropdown-toggle {
  color: #b0a7b2;
  background-color: #fafbfd;
  border-color: #fafbfd;
}

.btn-check:checked + .btn-light:focus,
.btn-check:active + .btn-light:focus,
.btn-light:active:focus,
.btn-light.active:focus,
.show > .btn-light.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
  box-shadow: 0 0 0 0 rgba(238, 238, 242, 0.5);
}

.btn-light:disabled,
.btn-light.disabled {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-dark {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-dark:hover {
  color: #fff;
  background-color: #3a1d40;
  border-color: #361b3c;
}

.btn-check:focus + .btn-dark,
.btn-dark:focus {
  color: #fff;
  background-color: #3a1d40;
  border-color: #361b3c;
  -webkit-box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
  box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
}

.btn-check:checked + .btn-dark,
.btn-check:active + .btn-dark,
.btn-dark:active,
.btn-dark.active,
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #361b3c;
  border-color: #331a38;
}

.btn-check:checked + .btn-dark:focus,
.btn-check:active + .btn-dark:focus,
.btn-dark:active:focus,
.btn-dark.active:focus,
.show > .btn-dark.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
  box-shadow: 0 0 0 0 rgba(96, 67, 102, 0.5);
}

.btn-dark:disabled,
.btn-dark.disabled {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-outline-primary {
  color: #717cff;
  border-color: #717cff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-check:focus + .btn-outline-primary,
.btn-outline-primary:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
}

.btn-check:checked + .btn-outline-primary,
.btn-check:active + .btn-outline-primary,
.btn-outline-primary:active,
.btn-outline-primary.active,
.btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.btn-check:checked + .btn-outline-primary:focus,
.btn-check:active + .btn-outline-primary:focus,
.btn-outline-primary:active:focus,
.btn-outline-primary.active:focus,
.btn-outline-primary.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
  box-shadow: 0 0 0 0 rgba(113, 124, 255, 0.5);
}

.btn-outline-primary:disabled,
.btn-outline-primary.disabled {
  color: #717cff;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #a79ca8;
  border-color: #a79ca8;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-check:focus + .btn-outline-secondary,
.btn-outline-secondary:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
  box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
}

.btn-check:checked + .btn-outline-secondary,
.btn-check:active + .btn-outline-secondary,
.btn-outline-secondary:active,
.btn-outline-secondary.active,
.btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #a79ca8;
  border-color: #a79ca8;
}

.btn-check:checked + .btn-outline-secondary:focus,
.btn-check:active + .btn-outline-secondary:focus,
.btn-outline-secondary:active:focus,
.btn-outline-secondary.active:focus,
.btn-outline-secondary.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
  box-shadow: 0 0 0 0 rgba(167, 156, 168, 0.5);
}

.btn-outline-secondary:disabled,
.btn-outline-secondary.disabled {
  color: #a79ca8;
  background-color: transparent;
}

.btn-outline-success {
  color: #5fa500;
  border-color: #5fa500;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-check:focus + .btn-outline-success,
.btn-outline-success:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
  box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
}

.btn-check:checked + .btn-outline-success,
.btn-check:active + .btn-outline-success,
.btn-outline-success:active,
.btn-outline-success.active,
.btn-outline-success.dropdown-toggle.show {
  color: #fff;
  background-color: #5fa500;
  border-color: #5fa500;
}

.btn-check:checked + .btn-outline-success:focus,
.btn-check:active + .btn-outline-success:focus,
.btn-outline-success:active:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
  box-shadow: 0 0 0 0 rgba(95, 165, 0, 0.5);
}

.btn-outline-success:disabled,
.btn-outline-success.disabled {
  color: #5fa500;
  background-color: transparent;
}

.btn-outline-info {
  color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-check:focus + .btn-outline-info,
.btn-outline-info:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
  box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
}

.btn-check:checked + .btn-outline-info,
.btn-check:active + .btn-outline-info,
.btn-outline-info:active,
.btn-outline-info.active,
.btn-outline-info.dropdown-toggle.show {
  color: #fff;
  background-color: #3eb8f4;
  border-color: #3eb8f4;
}

.btn-check:checked + .btn-outline-info:focus,
.btn-check:active + .btn-outline-info:focus,
.btn-outline-info:active:focus,
.btn-outline-info.active:focus,
.btn-outline-info.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
  box-shadow: 0 0 0 0 rgba(62, 184, 244, 0.5);
}

.btn-outline-info:disabled,
.btn-outline-info.disabled {
  color: #3eb8f4;
  background-color: transparent;
}

.btn-outline-warning {
  color: #ffee25;
  border-color: #ffee25;
}

.btn-outline-warning:hover {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-check:focus + .btn-outline-warning,
.btn-outline-warning:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
}

.btn-check:checked + .btn-outline-warning,
.btn-check:active + .btn-outline-warning,
.btn-outline-warning:active,
.btn-outline-warning.active,
.btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #ffee25;
  border-color: #ffee25;
}

.btn-check:checked + .btn-outline-warning:focus,
.btn-check:active + .btn-outline-warning:focus,
.btn-outline-warning:active:focus,
.btn-outline-warning.active:focus,
.btn-outline-warning.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 238, 37, 0.5);
}

.btn-outline-warning:disabled,
.btn-outline-warning.disabled {
  color: #ffee25;
  background-color: transparent;
}

.btn-outline-danger {
  color: #ff717c;
  border-color: #ff717c;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
}

.btn-check:checked + .btn-outline-danger,
.btn-check:active + .btn-outline-danger,
.btn-outline-danger:active,
.btn-outline-danger.active,
.btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #ff717c;
  border-color: #ff717c;
}

.btn-check:checked + .btn-outline-danger:focus,
.btn-check:active + .btn-outline-danger:focus,
.btn-outline-danger:active:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
  box-shadow: 0 0 0 0 rgba(255, 113, 124, 0.5);
}

.btn-outline-danger:disabled,
.btn-outline-danger.disabled {
  color: #ff717c;
  background-color: transparent;
}

.btn-outline-light {
  color: #f9fafd;
  border-color: #f9fafd;
}

.btn-outline-light:hover {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-check:focus + .btn-outline-light,
.btn-outline-light:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
  box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
}

.btn-check:checked + .btn-outline-light,
.btn-check:active + .btn-outline-light,
.btn-outline-light:active,
.btn-outline-light.active,
.btn-outline-light.dropdown-toggle.show {
  color: #b0a7b2;
  background-color: #f9fafd;
  border-color: #f9fafd;
}

.btn-check:checked + .btn-outline-light:focus,
.btn-check:active + .btn-outline-light:focus,
.btn-outline-light:active:focus,
.btn-outline-light.active:focus,
.btn-outline-light.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
  box-shadow: 0 0 0 0 rgba(249, 250, 253, 0.5);
}

.btn-outline-light:disabled,
.btn-outline-light.disabled {
  color: #f9fafd;
  background-color: transparent;
}

.btn-outline-dark {
  color: #44224b;
  border-color: #44224b;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-check:focus + .btn-outline-dark,
.btn-outline-dark:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
  box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
}

.btn-check:checked + .btn-outline-dark,
.btn-check:active + .btn-outline-dark,
.btn-outline-dark:active,
.btn-outline-dark.active,
.btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #44224b;
  border-color: #44224b;
}

.btn-check:checked + .btn-outline-dark:focus,
.btn-check:active + .btn-outline-dark:focus,
.btn-outline-dark:active:focus,
.btn-outline-dark.active:focus,
.btn-outline-dark.dropdown-toggle.show:focus {
  -webkit-box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
  box-shadow: 0 0 0 0 rgba(68, 34, 75, 0.5);
}

.btn-outline-dark:disabled,
.btn-outline-dark.disabled {
  color: #44224b;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #717cff;
  text-decoration: none;
}

.btn-link:hover {
  color: #5a63cc;
  text-decoration: underline;
}

.btn-link:focus {
  text-decoration: underline;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #c3bcc4;
}

.btn-lg,
.btn-group-lg > .btn {
  padding: 0.7rem 1.8rem;
  font-size: 1rem;
  border-radius: 0.625rem;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.1rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.625rem;
}

.fade {
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  -webkit-transition: height 0.35s ease;
  -o-transition: height 0.35s ease;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 1rem;
  color: #778295;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu[data-bs-popper] {
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
}

@media (min-width: 576px) {
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-end {
    --bs-position: end;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
}

@media (min-width: 1540px) {
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
}

.dropend .dropdown-menu[data-bs-popper] {
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
}

.dropstart .dropdown-menu[data-bs-popper] {
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #a79ca8;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #968c97;
  text-decoration: none;
  background-color: #e8e5e9;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #717cff;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #ccc6cd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #c3bcc4;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1rem;
  color: #a79ca8;
}

.dropdown-menu-dark {
  color: #dfdbdf;
  background-color: #b0a7b2;
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item {
  color: #dfdbdf;
}

.dropdown-menu-dark .dropdown-item:hover,
.dropdown-menu-dark .dropdown-item:focus {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
  color: #fff;
  background-color: #717cff;
}

.dropdown-menu-dark .dropdown-item.disabled,
.dropdown-menu-dark .dropdown-item:disabled {
  color: #ccc6cd;
}

.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}

.dropdown-menu-dark .dropdown-item-text {
  color: #dfdbdf;
}

.dropdown-menu-dark .dropdown-header {
  color: #ccc6cd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn:nth-child(n + 3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.35rem;
  padding-left: 1.35rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split,
.btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split,
.btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.35rem;
  padding-left: 1.35rem;
}

.btn-group-vertical {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #c3bcc4;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dfdbdf;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e8e5e9 #e8e5e9 #dfdbdf;
  isolation: isolate;
}

.nav-tabs .nav-link.disabled {
  color: #c3bcc4;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #b9b1bb;
  background-color: #fff;
  border-color: #dfdbdf #dfdbdf #fff;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #717cff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: inherit;
  flex-wrap: inherit;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: -0.046rem;
  padding-bottom: -0.046rem;
  margin-right: 1rem;
  font-size: calc(1.2978rem + 0.5736vw);
  white-space: nowrap;
}

@media (min-width: 1200px) {
  .navbar-brand {
    font-size: 1.728rem;
  }
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.2rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.313rem;
  -webkit-transition: -webkit-box-shadow 0.15s ease-in-out;
  transition: -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: box-shadow 0.15s ease-in-out;
  transition: box-shadow 0.15s ease-in-out;
  transition: box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
}

@media (min-width: 1540px) {
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: #717cff;
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: #717cff;
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.25);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: #717cff;
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.95);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url([svg]);
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.95);
}

.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: #717cff;
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.9);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url([svg]);
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 2px);
  border-top-right-radius: calc(0.25rem - 2px);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 2px);
  border-bottom-left-radius: calc(0.25rem - 2px);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 1rem;
}

.card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background-color: #faf9fa;
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 2px) calc(0.25rem - 2px) 0 0;
}

.card-footer {
  padding: 0.5rem 1rem;
  background-color: #faf9fa;
  border-top: 2px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 2px) calc(0.25rem - 2px);
}

.card-header-tabs {
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
  margin-left: -0.5rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  border-radius: calc(0.25rem - 2px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 2px);
  border-top-right-radius: calc(0.25rem - 2px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 2px);
  border-bottom-left-radius: calc(0.25rem - 2px);
}

.card-group > .card {
  margin-bottom: 1rem;
}

@media (min-width: 576px) {
  .card-group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
}

@media (min-width: 576px) {
  .card-group > .card {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-bottom: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.breadcrumb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #c3bcc4;
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: #c3bcc4;
}

.pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #717cff;
  background-color: #fff;
  border: 1px solid #dfdbdf;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: #5a63cc;
  text-decoration: none;
  background-color: #e8e5e9;
  border-color: #dfdbdf;
}

.page-link:focus {
  z-index: 3;
  color: #5a63cc;
  background-color: #e8e5e9;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.page-item.disabled .page-link {
  color: #c3bcc4;
  pointer-events: none;
  background-color: #fff;
  border-color: #dfdbdf;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.2rem;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  color: #444a99;
  background-color: #e3e5ff;
  border-color: #d4d8ff;
}

.alert-primary .alert-link {
  color: #363b7a;
}

.alert-secondary {
  color: #645e65;
  background-color: #edebee;
  border-color: #e5e1e5;
}

.alert-secondary .alert-link {
  color: #504b51;
}

.alert-success {
  color: #396300;
  background-color: #dfedcc;
  border-color: #cfe4b3;
}

.alert-success .alert-link {
  color: #2e4f00;
}

.alert-info {
  color: #256e92;
  background-color: #d8f1fd;
  border-color: #c5eafc;
}

.alert-info .alert-link {
  color: #1e5875;
}

.alert-warning {
  color: #998f16;
  background-color: #fffcd3;
  border-color: #fffabe;
}

.alert-warning .alert-link {
  color: #7a7212;
}

.alert-danger {
  color: #99444a;
  background-color: #ffe3e5;
  border-color: #ffd4d8;
}

.alert-danger .alert-link {
  color: #7a363b;
}

.alert-light {
  color: #959698;
  background-color: #fefeff;
  border-color: #fdfefe;
}

.alert-light .alert-link {
  color: #77787a;
}

.alert-dark {
  color: #29142d;
  background-color: #dad3db;
  border-color: #c7bdc9;
}

.alert-dark .alert-link {
  color: #211024;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e8e5e9;
  border-radius: 0.25rem;
}

.progress-bar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #717cff;
  -webkit-transition: width 0.6s ease;
  -o-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.progress-bar-striped {
  background-image: -o-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  -webkit-animation: 1s linear infinite progress-bar-stripes;
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    -webkit-animation: none;
    animation: none;
  }
}

.list-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #b9b1bb;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #b9b1bb;
  text-decoration: none;
  background-color: #fafafa;
}

.list-group-item-action:active {
  color: #778295;
  background-color: #e8e5e9;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  color: #a79ca8;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #c3bcc4;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #717cff;
  border-color: #717cff;
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 576px) {
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
}

@media (min-width: 1540px) {
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #444a99;
  background-color: #e3e5ff;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
  color: #444a99;
  background-color: #cccee6;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #444a99;
  border-color: #444a99;
}

.list-group-item-secondary {
  color: #645e65;
  background-color: #edebee;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
  color: #645e65;
  background-color: #d5d4d6;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #645e65;
  border-color: #645e65;
}

.list-group-item-success {
  color: #396300;
  background-color: #dfedcc;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
  color: #396300;
  background-color: #c9d5b8;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #396300;
  border-color: #396300;
}

.list-group-item-info {
  color: #256e92;
  background-color: #d8f1fd;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
  color: #256e92;
  background-color: #c2d9e4;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #256e92;
  border-color: #256e92;
}

.list-group-item-warning {
  color: #998f16;
  background-color: #fffcd3;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
  color: #998f16;
  background-color: #e6e3be;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #998f16;
  border-color: #998f16;
}

.list-group-item-danger {
  color: #99444a;
  background-color: #ffe3e5;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
  color: #99444a;
  background-color: #e6ccce;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #99444a;
  border-color: #99444a;
}

.list-group-item-light {
  color: #959698;
  background-color: #fefeff;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
  color: #959698;
  background-color: #e5e5e6;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #959698;
  border-color: #959698;
}

.list-group-item-dark {
  color: #29142d;
  background-color: #dad3db;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
  color: #29142d;
  background-color: #c4bec5;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #29142d;
  border-color: #29142d;
}

.btn-close {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url([svg]) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}

.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}

.btn-close:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(113, 124, 255, 0.25);
  opacity: 1;
}

.btn-close:disabled,
.btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  -webkit-filter: invert(1) grayscale(100%) brightness(200%);
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe;
  box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe;
  border-radius: 0.25rem;
}

.toast:not(.showing):not(.show) {
  opacity: 0;
}

.toast.hide {
  display: none;
}

.toast-container {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: 1rem;
}

.toast-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.5rem 0.75rem;
  color: #c3bcc4;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  -webkit-transition: -webkit-transform 0.3s ease-out;
  transition: -webkit-transform 0.3s ease-out;
  -o-transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
  -webkit-transform: translate(0, -50px);
  -ms-transform: translate(0, -50px);
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.modal.show .modal-dialog {
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}

.modal.modal-static .modal-dialog {
  -webkit-transform: scale(1.02);
  -ms-transform: scale(1.02);
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1.25rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dfdbdf;
  border-top-left-radius: calc(1.25rem - 1px);
  border-top-right-radius: calc(1.25rem - 1px);
}

.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dfdbdf;
  border-bottom-right-radius: calc(1.25rem - 1px);
  border-bottom-left-radius: calc(1.25rem - 1px);
}

.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
}

@media (min-width: 576px) {
  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }
}

@media (min-width: 576px) {
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
}

@media (min-width: 576px) {
  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1539.98px) {
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}

.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[data-popper-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: 0;
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end,
.bs-tooltip-auto[data-popper-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[data-popper-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: 0;
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start,
.bs-tooltip-auto[data-popper-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1070;
  display: block;
  max-width: 276px;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1.25rem;
}

.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-end > .popover-arrow,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-end > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f0f0f0;
}

.bs-popover-start > .popover-arrow,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}

.bs-popover-start > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #091e40;
  background-color: #f0f0f0;
  border-bottom: 1px solid #d8d8d8;
  border-top-left-radius: calc(1.25rem - 1px);
  border-top-right-radius: calc(1.25rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1rem 1rem;
  color: #778295;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.6s ease-in-out;
  transition: -webkit-transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  -webkit-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  -webkit-transition: opacity 0s 0.6s;
  -o-transition: opacity 0s 0.6s;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #778295;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.9;
  -webkit-transition: opacity 0.15s ease;
  -o-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #778295;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url([svg]);
}

.carousel-control-next-icon {
  background-image: url([svg]);
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 7px;
  height: 7px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #717cff;
  background-clip: padding-box;
  border: 0;
  border-top: 0 solid transparent;
  border-bottom: 0 solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  -o-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  -webkit-filter: invert(1) grayscale(100);
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  -webkit-animation: 0.75s linear infinite spinner-grow;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }
}

.accordion-button {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: 1.5rem 2.6rem;
  font-size: 1rem;
  color: #778295;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, border-radius 0.15s ease,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease, -webkit-box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: #44224b;
  background-color: #fff;
  -webkit-box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.125);
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.125);
}

.accordion-button:not(.collapsed)::after {
  background-image: url("");
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.accordion-button::after {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 1.8rem;
  height: 1.8rem;
  margin-left: auto;
  content: "";
  background-image: url("");
  background-repeat: no-repeat;
  background-size: 1.8rem;
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  -o-transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: #fff;
  outline: 0;
  -webkit-box-shadow: #f9fafd;
  box-shadow: #f9fafd;
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.125);
}

.accordion-item:first-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-item:last-of-type {
  margin-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion-body {
  padding: 1.5rem 2.6rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-primary {
  color: #717cff;
}

.link-primary:hover,
.link-primary:focus {
  color: #5a63cc;
}

.link-secondary {
  color: #a79ca8;
}

.link-secondary:hover,
.link-secondary:focus {
  color: #867d86;
}

.link-success {
  color: #5fa500;
}

.link-success:hover,
.link-success:focus {
  color: #4c8400;
}

.link-info {
  color: #3eb8f4;
}

.link-info:hover,
.link-info:focus {
  color: #3293c3;
}

.link-warning {
  color: #ffee25;
}

.link-warning:hover,
.link-warning:focus {
  color: #fff151;
}

.link-danger {
  color: #ff717c;
}

.link-danger:hover,
.link-danger:focus {
  color: #cc5a63;
}

.link-light {
  color: #f9fafd;
}

.link-light:hover,
.link-light:focus {
  color: #fafbfd;
}

.link-dark {
  color: #44224b;
}

.link-dark:hover,
.link-dark:focus {
  color: #361b3c;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

@media (min-width: 1540px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.d-inline-flex {
  display: -webkit-inline-box !important;
  display: -ms-inline-flexbox !important;
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  -webkit-box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe !important;
  box-shadow: 0 0.6375rem 0.975rem 0 #f4f8fe, 0 3px 6px 0 #f4f8fe !important;
}

.shadow-sm {
  -webkit-box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15) !important;
  box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15) !important;
}

.shadow-lg {
  -webkit-box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-absolute {
  position: absolute !important;
}

.position-relative {
  position: relative !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  -webkit-transform: translateX(-50%) translateY(-50%) !important;
  -ms-transform: translateX(-50%) translateY(-50%) !important;
  transform: translateX(-50%) translateY(-50%) !important;
}

.translate-middle-x {
  -webkit-transform: translateX(-50%) !important;
  -ms-transform: translateX(-50%) !important;
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  -webkit-transform: translateY(-50%) !important;
  -ms-transform: translateY(-50%) !important;
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dfdbdf !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dfdbdf !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dfdbdf !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dfdbdf !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dfdbdf !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-facebook {
  border-color: #3c5a99 !important;
}

.border-google-plus {
  border-color: #dd4b39 !important;
}

.border-twitter {
  border-color: #1da1f2 !important;
}

.border-linkedin {
  border-color: #0077b5 !important;
}

.border-youtube {
  border-color: red !important;
}

.border-github {
  border-color: #333 !important;
}

.border-black {
  border-color: #000 !important;
}

.border-100 {
  border-color: #fafafa !important;
}

.border-200 {
  border-color: #e8e5e9 !important;
}

.border-300 {
  border-color: #dfdbdf !important;
}

.border-400 {
  border-color: #d5d1d6 !important;
}

.border-500 {
  border-color: #ccc6cd !important;
}

.border-600 {
  border-color: #c3bcc4 !important;
}

.border-700 {
  border-color: #b9b1bb !important;
}

.border-800 {
  border-color: #b0a7b2 !important;
}

.border-900 {
  border-color: #a79ca8 !important;
}

.border-1000 {
  border-color: #778295 !important;
}

.border-1100 {
  border-color: #44224b !important;
}

.border-1200 {
  border-color: #091e40 !important;
}

.border-white {
  border-color: #fff !important;
}

.border-primary {
  border-color: #717cff !important;
}

.border-secondary {
  border-color: #a79ca8 !important;
}

.border-success {
  border-color: #5fa500 !important;
}

.border-info {
  border-color: #3eb8f4 !important;
}

.border-warning {
  border-color: #ffee25 !important;
}

.border-danger {
  border-color: #ff717c !important;
}

.border-light {
  border-color: #f9fafd !important;
}

.border-dark {
  border-color: #44224b !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-25 {
  width: 25vw !important;
}

.vw-50 {
  width: 50vw !important;
}

.vw-75 {
  width: 75vw !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-25 {
  height: 25vh !important;
}

.vh-50 {
  height: 50vh !important;
}

.vh-75 {
  height: 75vh !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-25 {
  min-height: 25vh !important;
}

.min-vh-50 {
  min-height: 50vh !important;
}

.min-vh-75 {
  min-height: 75vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  -webkit-box-flex: 1 !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
}

.flex-row {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
}

.flex-column {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: column !important;
  flex-direction: column !important;
}

.flex-row-reverse {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: reverse !important;
  -ms-flex-direction: row-reverse !important;
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: reverse !important;
  -ms-flex-direction: column-reverse !important;
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  -webkit-box-flex: 0 !important;
  -ms-flex-positive: 0 !important;
  flex-grow: 0 !important;
}

.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  -ms-flex-negative: 1 !important;
  flex-shrink: 1 !important;
}

.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}

.flex-nowrap {
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  -ms-flex-wrap: wrap-reverse !important;
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.8rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-6 {
  gap: 4rem !important;
}

.gap-7 {
  gap: 5rem !important;
}

.gap-8 {
  gap: 7.5rem !important;
}

.gap-9 {
  gap: 10rem !important;
}

.gap-10 {
  gap: 12.5rem !important;
}

.gap-11 {
  gap: 15rem !important;
}

.justify-content-start {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
}

.justify-content-end {
  -webkit-box-pack: end !important;
  -ms-flex-pack: end !important;
  justify-content: flex-end !important;
}

.justify-content-center {
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.justify-content-between {
  -webkit-box-pack: justify !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}

.justify-content-around {
  -ms-flex-pack: distribute !important;
  justify-content: space-around !important;
}

.justify-content-evenly {
  -webkit-box-pack: space-evenly !important;
  -ms-flex-pack: space-evenly !important;
  justify-content: space-evenly !important;
}

.align-items-start {
  -webkit-box-align: start !important;
  -ms-flex-align: start !important;
  align-items: flex-start !important;
}

.align-items-end {
  -webkit-box-align: end !important;
  -ms-flex-align: end !important;
  align-items: flex-end !important;
}

.align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.align-items-baseline {
  -webkit-box-align: baseline !important;
  -ms-flex-align: baseline !important;
  align-items: baseline !important;
}

.align-items-stretch {
  -webkit-box-align: stretch !important;
  -ms-flex-align: stretch !important;
  align-items: stretch !important;
}

.align-content-start {
  -ms-flex-line-pack: start !important;
  align-content: flex-start !important;
}

.align-content-end {
  -ms-flex-line-pack: end !important;
  align-content: flex-end !important;
}

.align-content-center {
  -ms-flex-line-pack: center !important;
  align-content: center !important;
}

.align-content-between {
  -ms-flex-line-pack: justify !important;
  align-content: space-between !important;
}

.align-content-around {
  -ms-flex-line-pack: distribute !important;
  align-content: space-around !important;
}

.align-content-stretch {
  -ms-flex-line-pack: stretch !important;
  align-content: stretch !important;
}

.align-self-auto {
  -ms-flex-item-align: auto !important;
  align-self: auto !important;
}

.align-self-start {
  -ms-flex-item-align: start !important;
  align-self: flex-start !important;
}

.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.align-self-baseline {
  -ms-flex-item-align: baseline !important;
  align-self: baseline !important;
}

.align-self-stretch {
  -ms-flex-item-align: stretch !important;
  align-self: stretch !important;
}

.order-first {
  -webkit-box-ordinal-group: 0 !important;
  -ms-flex-order: -1 !important;
  order: -1 !important;
}

.order-0 {
  -webkit-box-ordinal-group: 1 !important;
  -ms-flex-order: 0 !important;
  order: 0 !important;
}

.order-1 {
  -webkit-box-ordinal-group: 2 !important;
  -ms-flex-order: 1 !important;
  order: 1 !important;
}

.order-2 {
  -webkit-box-ordinal-group: 3 !important;
  -ms-flex-order: 2 !important;
  order: 2 !important;
}

.order-3 {
  -webkit-box-ordinal-group: 4 !important;
  -ms-flex-order: 3 !important;
  order: 3 !important;
}

.order-4 {
  -webkit-box-ordinal-group: 5 !important;
  -ms-flex-order: 4 !important;
  order: 4 !important;
}

.order-5 {
  -webkit-box-ordinal-group: 6 !important;
  -ms-flex-order: 5 !important;
  order: 5 !important;
}

.order-last {
  -webkit-box-ordinal-group: 7 !important;
  -ms-flex-order: 6 !important;
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.8rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-6 {
  margin: 4rem !important;
}

.m-7 {
  margin: 5rem !important;
}

.m-8 {
  margin: 7.5rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.m-10 {
  margin: 12.5rem !important;
}

.m-11 {
  margin: 15rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.8rem !important;
  margin-left: 1.8rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-6 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-7 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-8 {
  margin-right: 7.5rem !important;
  margin-left: 7.5rem !important;
}

.mx-9 {
  margin-right: 10rem !important;
  margin-left: 10rem !important;
}

.mx-10 {
  margin-right: 12.5rem !important;
  margin-left: 12.5rem !important;
}

.mx-11 {
  margin-right: 15rem !important;
  margin-left: 15rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.8rem !important;
  margin-bottom: 1.8rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-6 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-7 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-8 {
  margin-top: 7.5rem !important;
  margin-bottom: 7.5rem !important;
}

.my-9 {
  margin-top: 10rem !important;
  margin-bottom: 10rem !important;
}

.my-10 {
  margin-top: 12.5rem !important;
  margin-bottom: 12.5rem !important;
}

.my-11 {
  margin-top: 15rem !important;
  margin-bottom: 15rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.8rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-6 {
  margin-top: 4rem !important;
}

.mt-7 {
  margin-top: 5rem !important;
}

.mt-8 {
  margin-top: 7.5rem !important;
}

.mt-9 {
  margin-top: 10rem !important;
}

.mt-10 {
  margin-top: 12.5rem !important;
}

.mt-11 {
  margin-top: 15rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.8rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-6 {
  margin-right: 4rem !important;
}

.me-7 {
  margin-right: 5rem !important;
}

.me-8 {
  margin-right: 7.5rem !important;
}

.me-9 {
  margin-right: 10rem !important;
}

.me-10 {
  margin-right: 12.5rem !important;
}

.me-11 {
  margin-right: 15rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.8rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-6 {
  margin-bottom: 4rem !important;
}

.mb-7 {
  margin-bottom: 5rem !important;
}

.mb-8 {
  margin-bottom: 7.5rem !important;
}

.mb-9 {
  margin-bottom: 10rem !important;
}

.mb-10 {
  margin-bottom: 12.5rem !important;
}

.mb-11 {
  margin-bottom: 15rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.8rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-6 {
  margin-left: 4rem !important;
}

.ms-7 {
  margin-left: 5rem !important;
}

.ms-8 {
  margin-left: 7.5rem !important;
}

.ms-9 {
  margin-left: 10rem !important;
}

.ms-10 {
  margin-left: 12.5rem !important;
}

.ms-11 {
  margin-left: 15rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.8rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.m-n6 {
  margin: -4rem !important;
}

.m-n7 {
  margin: -5rem !important;
}

.m-n8 {
  margin: -7.5rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.m-n10 {
  margin: -12.5rem !important;
}

.m-n11 {
  margin: -15rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.8rem !important;
  margin-left: -1.8rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n6 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n7 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.mx-n8 {
  margin-right: -7.5rem !important;
  margin-left: -7.5rem !important;
}

.mx-n9 {
  margin-right: -10rem !important;
  margin-left: -10rem !important;
}

.mx-n10 {
  margin-right: -12.5rem !important;
  margin-left: -12.5rem !important;
}

.mx-n11 {
  margin-right: -15rem !important;
  margin-left: -15rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.8rem !important;
  margin-bottom: -1.8rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n6 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n7 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.my-n8 {
  margin-top: -7.5rem !important;
  margin-bottom: -7.5rem !important;
}

.my-n9 {
  margin-top: -10rem !important;
  margin-bottom: -10rem !important;
}

.my-n10 {
  margin-top: -12.5rem !important;
  margin-bottom: -12.5rem !important;
}

.my-n11 {
  margin-top: -15rem !important;
  margin-bottom: -15rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.8rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.mt-n6 {
  margin-top: -4rem !important;
}

.mt-n7 {
  margin-top: -5rem !important;
}

.mt-n8 {
  margin-top: -7.5rem !important;
}

.mt-n9 {
  margin-top: -10rem !important;
}

.mt-n10 {
  margin-top: -12.5rem !important;
}

.mt-n11 {
  margin-top: -15rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.8rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.me-n6 {
  margin-right: -4rem !important;
}

.me-n7 {
  margin-right: -5rem !important;
}

.me-n8 {
  margin-right: -7.5rem !important;
}

.me-n9 {
  margin-right: -10rem !important;
}

.me-n10 {
  margin-right: -12.5rem !important;
}

.me-n11 {
  margin-right: -15rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.8rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.mb-n6 {
  margin-bottom: -4rem !important;
}

.mb-n7 {
  margin-bottom: -5rem !important;
}

.mb-n8 {
  margin-bottom: -7.5rem !important;
}

.mb-n9 {
  margin-bottom: -10rem !important;
}

.mb-n10 {
  margin-bottom: -12.5rem !important;
}

.mb-n11 {
  margin-bottom: -15rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.8rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.ms-n6 {
  margin-left: -4rem !important;
}

.ms-n7 {
  margin-left: -5rem !important;
}

.ms-n8 {
  margin-left: -7.5rem !important;
}

.ms-n9 {
  margin-left: -10rem !important;
}

.ms-n10 {
  margin-left: -12.5rem !important;
}

.ms-n11 {
  margin-left: -15rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.8rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-6 {
  padding: 4rem !important;
}

.p-7 {
  padding: 5rem !important;
}

.p-8 {
  padding: 7.5rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.p-10 {
  padding: 12.5rem !important;
}

.p-11 {
  padding: 15rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.8rem !important;
  padding-left: 1.8rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-6 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-7 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.px-8 {
  padding-right: 7.5rem !important;
  padding-left: 7.5rem !important;
}

.px-9 {
  padding-right: 10rem !important;
  padding-left: 10rem !important;
}

.px-10 {
  padding-right: 12.5rem !important;
  padding-left: 12.5rem !important;
}

.px-11 {
  padding-right: 15rem !important;
  padding-left: 15rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.8rem !important;
  padding-bottom: 1.8rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-6 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-7 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.py-8 {
  padding-top: 7.5rem !important;
  padding-bottom: 7.5rem !important;
}

.py-9 {
  padding-top: 10rem !important;
  padding-bottom: 10rem !important;
}

.py-10 {
  padding-top: 12.5rem !important;
  padding-bottom: 12.5rem !important;
}

.py-11 {
  padding-top: 15rem !important;
  padding-bottom: 15rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.8rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-6 {
  padding-top: 4rem !important;
}

.pt-7 {
  padding-top: 5rem !important;
}

.pt-8 {
  padding-top: 7.5rem !important;
}

.pt-9 {
  padding-top: 10rem !important;
}

.pt-10 {
  padding-top: 12.5rem !important;
}

.pt-11 {
  padding-top: 15rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.8rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-6 {
  padding-right: 4rem !important;
}

.pe-7 {
  padding-right: 5rem !important;
}

.pe-8 {
  padding-right: 7.5rem !important;
}

.pe-9 {
  padding-right: 10rem !important;
}

.pe-10 {
  padding-right: 12.5rem !important;
}

.pe-11 {
  padding-right: 15rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.8rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-6 {
  padding-bottom: 4rem !important;
}

.pb-7 {
  padding-bottom: 5rem !important;
}

.pb-8 {
  padding-bottom: 7.5rem !important;
}

.pb-9 {
  padding-bottom: 10rem !important;
}

.pb-10 {
  padding-bottom: 12.5rem !important;
}

.pb-11 {
  padding-bottom: 15rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.8rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-6 {
  padding-left: 4rem !important;
}

.ps-7 {
  padding-left: 5rem !important;
}

.ps-8 {
  padding-left: 7.5rem !important;
}

.ps-9 {
  padding-left: 10rem !important;
}

.ps-10 {
  padding-left: 12.5rem !important;
}

.ps-11 {
  padding-left: 15rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs--2 {
  font-size: 0.69444rem !important;
}

.fs--1 {
  font-size: 0.83333rem !important;
}

.fs-0 {
  font-size: 1rem !important;
}

.fs-1 {
  font-size: 1.2rem !important;
}

.fs-2 {
  font-size: 1.44rem !important;
}

.fs-3 {
  font-size: 1.728rem !important;
}

.fs-4 {
  font-size: 2.0736rem !important;
}

.fs-5 {
  font-size: 2.48832rem !important;
}

.fs-6 {
  font-size: 2.98598rem !important;
}

.fs-7 {
  font-size: 3.58318rem !important;
}

.fs-8 {
  font-size: 4.29982rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-thin {
  font-weight: 100 !important;
}

.fw-lighter {
  font-weight: 200 !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semi-bold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: 800 !important;
}

.fw-black {
  font-weight: 900 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.text-primary {
  color: #016b9d !important;
}

.text-secondary {
  color: #a79ca8 !important;
}

.text-success {
  color: #5fa500 !important;
}

.text-info {
  color: #3eb8f4 !important;
}

.text-warning {
  color: #ffee25 !important;
}

.text-danger {
  color: #ff717c !important;
}

.text-light {
  color: #f9fafd !important;
}

.text-dark {
  color: #44224b !important;
}

.text-white {
  color: #fff !important;
}

.text-body {
  color: #778295 !important;
}

.text-muted {
  color: #ccc6cd !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  color: inherit !important;
}

.bg-facebook {
  background-color: #3c5a99 !important;
}

.bg-google-plus {
  background-color: #dd4b39 !important;
}

.bg-twitter {
  background-color: #1da1f2 !important;
}

.bg-linkedin {
  background-color: #0077b5 !important;
}

.bg-youtube {
  background-color: red !important;
}

.bg-github {
  background-color: #333 !important;
}

.bg-black {
  background-color: #000 !important;
}

.bg-100 {
  background-color: #fafafa !important;
  padding-top: 0.25rem;
}

.bg-200 {
  background-color: #e8e5e9 !important;
  padding-top: 0.25rem;
}

.bg-300 {
  background-color: #dfdbdf !important;
}

.bg-400 {
  background-color: #d5d1d6 !important;
}

.bg-500 {
  background-color: #ccc6cd !important;
}

.bg-600 {
  background-color: #c3bcc4 !important;
}

.bg-700 {
  background-color: #b9b1bb !important;
}

.bg-800 {
  background-color: #b0a7b2 !important;
}

.bg-900 {
  background-color: #a79ca8 !important;
}

.bg-1000 {
  background-color: #778295 !important;
}

.bg-1100 {
  background-color: #44224b !important;
}

.bg-1200 {
  background-color: #091e40 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-primary {
  background-color: #717cff !important;
}

.bg-secondary {
  background-color: #a79ca8 !important;
}

.bg-success {
  background-color: #5fa500 !important;
}

.bg-info {
  background-color: #3eb8f4 !important;
}

.bg-warning {
  background-color: #ffee25 !important;
}

.bg-danger {
  background-color: #ff717c !important;
}

.bg-light {
  background-color: #f9fafd !important;
}

.bg-dark {
  background-color: #44224b !important;
}

.bg-body {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: rgba(0, 0, 0, 0) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  -moz-user-select: all !important;
  -ms-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.625rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 1.25rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-start-radius: 0.25rem !important;
  border-top-end-radius: 0.25rem !important;
}

.rounded-top-lg {
  border-top-start-radius: 1.25rem !important;
  border-top-end-radius: 1.25rem !important;
}

.rounded-top-0 {
  border-top-start-radius: 0 !important;
  border-top-end-radius: 0 !important;
}

.rounded-end {
  border-top-end-radius: 0.25rem !important;
  border-bottom-end-radius: 0.25rem !important;
}

.rounded-end-lg {
  border-top-end-radius: 1.25rem !important;
  border-bottom-end-radius: 1.25rem !important;
}

.rounded-end-0 {
  border-top-end-radius: 0 !important;
  border-bottom-end-radius: 0 !important;
}

.rounded-bottom {
  border-bottom-end-radius: 0.25rem !important;
  border-bottom-start-radius: 0.25rem !important;
}

.rounded-bottom-lg {
  border-bottom-end-radius: 1.25rem !important;
  border-bottom-start-radius: 1.25rem !important;
}

.rounded-bottom-0 {
  border-bottom-end-radius: 0 !important;
  border-bottom-start-radius: 0 !important;
}

.rounded-start {
  border-bottom-start-radius: 0.25rem !important;
  border-top-start-radius: 0.25rem !important;
}

.rounded-start-lg {
  border-bottom-start-radius: 1.25rem !important;
  border-top-start-radius: 1.25rem !important;
}

.rounded-start-0 {
  border-bottom-start-radius: 0 !important;
  border-top-start-radius: 0 !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-85 {
  opacity: 0.85 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.text-facebook {
  color: #3c5a99 !important;
}

.text-google-plus {
  color: #dd4b39 !important;
}

.text-twitter {
  color: #1da1f2 !important;
}

.text-linkedin {
  color: #0077b5 !important;
}

.text-youtube {
  color: red !important;
}

.text-github {
  color: #333 !important;
}

.text-black {
  color: #000 !important;
}

.text-100 {
  color: #fafafa !important;
}

.text-200 {
  color: #e8e5e9 !important;
}

.text-300 {
  color: #dfdbdf !important;
}

.text-400 {
  color: #d5d1d6 !important;
}

.text-500 {
  color: #ccc6cd !important;
}

.text-600 {
  color: #c3bcc4 !important;
}

.text-700 {
  color: #b9b1bb !important;
}

.text-800 {
  color: #b0a7b2 !important;
}

.text-900 {
  color: #a79ca8 !important;
}

.text-1000 {
  color: #778295 !important;
}

.text-1100 {
  color: #44224b !important;
}

.text-1200 {
  color: #091e40 !important;
}

.text-white {
  color: #fff !important;
}

.max-vh-25 {
  max-height: 25vh !important;
}

.max-vh-50 {
  max-height: 50vh !important;
}

.max-vh-75 {
  max-height: 75vh !important;
}

.max-vh-100 {
  max-height: 100vh !important;
}

.border-x {
  border-left: 1px solid #dfdbdf !important;
  border-right: 1px solid #dfdbdf !important;
}

.border-x-0 {
  border-left: 0 !important;
  border-right: 0 !important;
}

.border-y {
  border-top: 1px solid #dfdbdf !important;
  border-bottom: 1px solid #dfdbdf !important;
}

.border-y-0 {
  border-top: 0 !important;
  border-bottom: 0 !important;
}

.border-dashed {
  border: 1px dashed #dfdbdf !important;
}

.border-dashed-top {
  border-top: 1px dashed #dfdbdf !important;
}

.border-dashed-end {
  border-right: 1px dashed #dfdbdf !important;
}

.border-dashed-start {
  border-left: 1px dashed #dfdbdf !important;
}

.border-dashed-bottom {
  border-bottom: 1px dashed #dfdbdf !important;
}

.border-dashed-x {
  border-left: 1px dashed #dfdbdf !important;
  border-right: 1px dashed #dfdbdf !important;
}

.border-dashed-y {
  border-top: 1px dashed #dfdbdf !important;
  border-bottom: 1px dashed #dfdbdf !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.bg-soft-primary {
  background-color: #f1f2ff !important;
}

.bg-soft-secondary {
  background-color: #f6f5f6 !important;
}

.bg-soft-success {
  background-color: #eff6e6 !important;
}

.bg-soft-info {
  background-color: #ecf8fe !important;
}

.bg-soft-warning {
  background-color: #fffde9 !important;
}

.bg-soft-danger {
  background-color: #fff1f2 !important;
}

.bg-soft-light {
  background-color: #feffff !important;
}

.bg-soft-dark {
  background-color: #ece9ed !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
}

@media (min-width: 576px) {
  .float-sm-end {
    float: right !important;
  }
}

@media (min-width: 576px) {
  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline {
    display: inline !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 576px) {
  .d-sm-block {
    display: block !important;
  }
}

@media (min-width: 576px) {
  .d-sm-grid {
    display: grid !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table {
    display: table !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table-row {
    display: table-row !important;
  }
}

@media (min-width: 576px) {
  .d-sm-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 576px) {
  .d-sm-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 576px) {
  .d-sm-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
}

@media (min-width: 576px) {
  .position-sm-static {
    position: static !important;
  }
}

@media (min-width: 576px) {
  .position-sm-absolute {
    position: absolute !important;
  }
}

@media (min-width: 576px) {
  .position-sm-relative {
    position: relative !important;
  }
}

@media (min-width: 576px) {
  .position-sm-fixed {
    position: fixed !important;
  }
}

@media (min-width: 576px) {
  .position-sm-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 576px) {
  .translate-sm-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 576px) {
  .border-sm {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-0 {
    border: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .w-sm-25 {
    width: 25% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-50 {
    width: 50% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-75 {
    width: 75% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-100 {
    width: 100% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-auto {
    width: auto !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-25 {
    width: 25vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-50 {
    width: 50vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-75 {
    width: 75vw !important;
  }
}

@media (min-width: 576px) {
  .vw-sm-100 {
    width: 100vw !important;
  }
}

@media (min-width: 576px) {
  .h-sm-25 {
    height: 25% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-50 {
    height: 50% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-75 {
    height: 75% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-100 {
    height: 100% !important;
  }
}

@media (min-width: 576px) {
  .h-sm-auto {
    height: auto !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-25 {
    height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-50 {
    height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-75 {
    height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .vh-sm-100 {
    height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .min-vh-sm-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 576px) {
  .flex-sm-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-0 {
    gap: 0 !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .gap-sm-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 576px) {
  .justify-content-sm-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 576px) {
  .align-items-sm-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 576px) {
  .align-content-sm-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 576px) {
  .align-self-sm-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 576px) {
  .order-sm-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 576px) {
  .order-sm-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
}

@media (min-width: 576px) {
  .m-sm-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-auto {
    margin: auto !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 576px) {
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 576px) {
  .me-sm-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .m-sm-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mx-sm-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .my-sm-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mt-sm-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .me-sm-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .mb-sm-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ms-sm-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-0 {
    padding: 0 !important;
  }
}

@media (min-width: 576px) {
  .p-sm-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .p-sm-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .px-sm-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .py-sm-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pt-sm-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pe-sm-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .pb-sm-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 576px) {
  .ps-sm-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 576px) {
  .fs-sm-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 576px) {
  .text-sm-start {
    text-align: left !important;
  }
}

@media (min-width: 576px) {
  .text-sm-end {
    text-align: right !important;
  }
}

@media (min-width: 576px) {
  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 576px) {
  .opacity-sm-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-youtube {
    color: red !important;
  }
}

@media (min-width: 576px) {
  .text-sm-github {
    color: #333 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-black {
    color: #000 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 576px) {
  .text-sm-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .text-sm-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 576px) {
  .text-sm-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 576px) {
  .text-sm-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 576px) {
  .text-sm-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 576px) {
  .text-sm-white {
    color: #fff !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 576px) {
  .max-vh-sm-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 576px) {
  .border-sm-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .border-sm-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 576px) {
  .rounded-sm-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
}

@media (min-width: 768px) {
  .float-md-end {
    float: right !important;
  }
}

@media (min-width: 768px) {
  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline {
    display: inline !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 768px) {
  .d-md-block {
    display: block !important;
  }
}

@media (min-width: 768px) {
  .d-md-grid {
    display: grid !important;
  }
}

@media (min-width: 768px) {
  .d-md-table {
    display: table !important;
  }
}

@media (min-width: 768px) {
  .d-md-table-row {
    display: table-row !important;
  }
}

@media (min-width: 768px) {
  .d-md-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 768px) {
  .d-md-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .position-md-static {
    position: static !important;
  }
}

@media (min-width: 768px) {
  .position-md-absolute {
    position: absolute !important;
  }
}

@media (min-width: 768px) {
  .position-md-relative {
    position: relative !important;
  }
}

@media (min-width: 768px) {
  .position-md-fixed {
    position: fixed !important;
  }
}

@media (min-width: 768px) {
  .position-md-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 768px) {
  .translate-md-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 768px) {
  .border-md {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-0 {
    border: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .w-md-25 {
    width: 25% !important;
  }
}

@media (min-width: 768px) {
  .w-md-50 {
    width: 50% !important;
  }
}

@media (min-width: 768px) {
  .w-md-75 {
    width: 75% !important;
  }
}

@media (min-width: 768px) {
  .w-md-100 {
    width: 100% !important;
  }
}

@media (min-width: 768px) {
  .w-md-auto {
    width: auto !important;
  }
}

@media (min-width: 768px) {
  .vw-md-25 {
    width: 25vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-50 {
    width: 50vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-75 {
    width: 75vw !important;
  }
}

@media (min-width: 768px) {
  .vw-md-100 {
    width: 100vw !important;
  }
}

@media (min-width: 768px) {
  .h-md-25 {
    height: 25% !important;
  }
}

@media (min-width: 768px) {
  .h-md-50 {
    height: 50% !important;
  }
}

@media (min-width: 768px) {
  .h-md-75 {
    height: 75% !important;
  }
}

@media (min-width: 768px) {
  .h-md-100 {
    height: 100% !important;
  }
}

@media (min-width: 768px) {
  .h-md-auto {
    height: auto !important;
  }
}

@media (min-width: 768px) {
  .vh-md-25 {
    height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-50 {
    height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-75 {
    height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .vh-md-100 {
    height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .min-vh-md-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .flex-md-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 768px) {
  .flex-md-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 768px) {
  .flex-md-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 768px) {
  .flex-md-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 768px) {
  .flex-md-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 768px) {
  .flex-md-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 768px) {
  .flex-md-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 768px) {
  .gap-md-0 {
    gap: 0 !important;
  }
}

@media (min-width: 768px) {
  .gap-md-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .gap-md-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 768px) {
  .justify-content-md-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 768px) {
  .align-items-md-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 768px) {
  .align-content-md-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 768px) {
  .align-self-md-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .order-md-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 768px) {
  .order-md-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 768px) {
  .order-md-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 768px) {
  .order-md-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 768px) {
  .order-md-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 768px) {
  .order-md-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 768px) {
  .order-md-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 768px) {
  .order-md-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
}

@media (min-width: 768px) {
  .m-md-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-auto {
    margin: auto !important;
  }
}

@media (min-width: 768px) {
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 768px) {
  .mt-md-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 768px) {
  .me-md-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 768px) {
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 768px) {
  .ms-md-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .m-md-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mx-md-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .my-md-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mt-md-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .me-md-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .mb-md-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ms-md-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-0 {
    padding: 0 !important;
  }
}

@media (min-width: 768px) {
  .p-md-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .p-md-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .px-md-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .py-md-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 768px) {
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pt-md-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pe-md-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .pb-md-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 768px) {
  .ps-md-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 768px) {
  .fs-md-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 768px) {
  .text-md-start {
    text-align: left !important;
  }
}

@media (min-width: 768px) {
  .text-md-end {
    text-align: right !important;
  }
}

@media (min-width: 768px) {
  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 768px) {
  .opacity-md-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 768px) {
  .text-md-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 768px) {
  .text-md-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 768px) {
  .text-md-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 768px) {
  .text-md-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 768px) {
  .text-md-youtube {
    color: red !important;
  }
}

@media (min-width: 768px) {
  .text-md-github {
    color: #333 !important;
  }
}

@media (min-width: 768px) {
  .text-md-black {
    color: #000 !important;
  }
}

@media (min-width: 768px) {
  .text-md-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 768px) {
  .text-md-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 768px) {
  .text-md-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .text-md-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 768px) {
  .text-md-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 768px) {
  .text-md-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 768px) {
  .text-md-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 768px) {
  .text-md-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 768px) {
  .text-md-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 768px) {
  .text-md-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 768px) {
  .text-md-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 768px) {
  .text-md-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 768px) {
  .text-md-white {
    color: #fff !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 768px) {
  .max-vh-md-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 768px) {
  .border-md-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .border-md-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 768px) {
  .rounded-md-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
}

@media (min-width: 992px) {
  .float-lg-end {
    float: right !important;
  }
}

@media (min-width: 992px) {
  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline {
    display: inline !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 992px) {
  .d-lg-block {
    display: block !important;
  }
}

@media (min-width: 992px) {
  .d-lg-grid {
    display: grid !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table {
    display: table !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table-row {
    display: table-row !important;
  }
}

@media (min-width: 992px) {
  .d-lg-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 992px) {
  .d-lg-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .position-lg-static {
    position: static !important;
  }
}

@media (min-width: 992px) {
  .position-lg-absolute {
    position: absolute !important;
  }
}

@media (min-width: 992px) {
  .position-lg-relative {
    position: relative !important;
  }
}

@media (min-width: 992px) {
  .position-lg-fixed {
    position: fixed !important;
  }
}

@media (min-width: 992px) {
  .position-lg-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 992px) {
  .translate-lg-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 992px) {
  .border-lg {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-0 {
    border: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .w-lg-25 {
    width: 25% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-50 {
    width: 50% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-75 {
    width: 75% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-100 {
    width: 100% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-auto {
    width: auto !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-25 {
    width: 25vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-50 {
    width: 50vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-75 {
    width: 75vw !important;
  }
}

@media (min-width: 992px) {
  .vw-lg-100 {
    width: 100vw !important;
  }
}

@media (min-width: 992px) {
  .h-lg-25 {
    height: 25% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-50 {
    height: 50% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-75 {
    height: 75% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-100 {
    height: 100% !important;
  }
}

@media (min-width: 992px) {
  .h-lg-auto {
    height: auto !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-25 {
    height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-50 {
    height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-75 {
    height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .vh-lg-100 {
    height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .min-vh-lg-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-0 {
    gap: 0 !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .gap-lg-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 992px) {
  .justify-content-lg-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 992px) {
  .align-items-lg-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 992px) {
  .align-content-lg-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 992px) {
  .align-self-lg-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .order-lg-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 992px) {
  .order-lg-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
}

@media (min-width: 992px) {
  .m-lg-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-auto {
    margin: auto !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 992px) {
  .me-lg-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .m-lg-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mx-lg-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .my-lg-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mt-lg-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .me-lg-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .mb-lg-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ms-lg-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-0 {
    padding: 0 !important;
  }
}

@media (min-width: 992px) {
  .p-lg-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .p-lg-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .px-lg-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .py-lg-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pt-lg-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pe-lg-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .pb-lg-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 992px) {
  .ps-lg-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 992px) {
  .fs-lg-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 992px) {
  .text-lg-start {
    text-align: left !important;
  }
}

@media (min-width: 992px) {
  .text-lg-end {
    text-align: right !important;
  }
}

@media (min-width: 992px) {
  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 992px) {
  .opacity-lg-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-youtube {
    color: red !important;
  }
}

@media (min-width: 992px) {
  .text-lg-github {
    color: #333 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-black {
    color: #000 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 992px) {
  .text-lg-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .text-lg-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 992px) {
  .text-lg-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 992px) {
  .text-lg-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 992px) {
  .text-lg-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 992px) {
  .text-lg-white {
    color: #fff !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 992px) {
  .max-vh-lg-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 992px) {
  .border-lg-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .border-lg-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 992px) {
  .rounded-lg-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-end {
    float: right !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline {
    display: inline !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-block {
    display: block !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-grid {
    display: grid !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table {
    display: table !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table-row {
    display: table-row !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-static {
    position: static !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-absolute {
    position: absolute !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-relative {
    position: relative !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-fixed {
    position: fixed !important;
  }
}

@media (min-width: 1200px) {
  .position-xl-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .translate-xl-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 1200px) {
  .border-xl {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-0 {
    border: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-25 {
    width: 25% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-50 {
    width: 50% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-75 {
    width: 75% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-100 {
    width: 100% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-auto {
    width: auto !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-25 {
    width: 25vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-50 {
    width: 50vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-75 {
    width: 75vw !important;
  }
}

@media (min-width: 1200px) {
  .vw-xl-100 {
    width: 100vw !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-25 {
    height: 25% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-50 {
    height: 50% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-75 {
    height: 75% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-100 {
    height: 100% !important;
  }
}

@media (min-width: 1200px) {
  .h-xl-auto {
    height: auto !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-25 {
    height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-50 {
    height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-75 {
    height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .vh-xl-100 {
    height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .min-vh-xl-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-0 {
    gap: 0 !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .gap-xl-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 1200px) {
  .justify-content-xl-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 1200px) {
  .align-items-xl-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 1200px) {
  .align-content-xl-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 1200px) {
  .align-self-xl-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 1200px) {
  .order-xl-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-auto {
    margin: auto !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mx-xl-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .my-xl-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mt-xl-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .me-xl-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .mb-xl-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ms-xl-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-0 {
    padding: 0 !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .p-xl-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .px-xl-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .py-xl-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pt-xl-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pe-xl-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .pb-xl-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1200px) {
  .ps-xl-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 1200px) {
  .fs-xl-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-start {
    text-align: left !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-end {
    text-align: right !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 1200px) {
  .opacity-xl-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-youtube {
    color: red !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-github {
    color: #333 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-black {
    color: #000 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-white {
    color: #fff !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 1200px) {
  .max-vh-xl-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .border-xl-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1200px) {
  .rounded-xl-0 {
    border-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-start {
    float: left !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-end {
    float: right !important;
  }
}

@media (min-width: 1540px) {
  .float-xxl-none {
    float: none !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline {
    display: inline !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline-block {
    display: inline-block !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-block {
    display: block !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-grid {
    display: grid !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table {
    display: table !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table-row {
    display: table-row !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-table-cell {
    display: table-cell !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
}

@media (min-width: 1540px) {
  .d-xxl-none {
    display: none !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-static {
    position: static !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-absolute {
    position: absolute !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-relative {
    position: relative !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-fixed {
    position: fixed !important;
  }
}

@media (min-width: 1540px) {
  .position-xxl-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle {
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
    -ms-transform: translateX(-50%) translateY(-50%) !important;
    transform: translateX(-50%) translateY(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle-x {
    -webkit-transform: translateX(-50%) !important;
    -ms-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .translate-xxl-middle-y {
    -webkit-transform: translateY(-50%) !important;
    -ms-transform: translateY(-50%) !important;
    transform: translateY(-50%) !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl {
    border: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-0 {
    border: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-top {
    border-top: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-top-0 {
    border-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-end {
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-end-0 {
    border-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-bottom {
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-bottom-0 {
    border-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-start {
    border-left: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-start-0 {
    border-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-25 {
    width: 25% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-50 {
    width: 50% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-75 {
    width: 75% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-100 {
    width: 100% !important;
  }
}

@media (min-width: 1540px) {
  .w-xxl-auto {
    width: auto !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-25 {
    width: 25vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-50 {
    width: 50vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-75 {
    width: 75vw !important;
  }
}

@media (min-width: 1540px) {
  .vw-xxl-100 {
    width: 100vw !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-25 {
    height: 25% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-50 {
    height: 50% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-75 {
    height: 75% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-100 {
    height: 100% !important;
  }
}

@media (min-width: 1540px) {
  .h-xxl-auto {
    height: auto !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-25 {
    height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-50 {
    height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-75 {
    height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .vh-xxl-100 {
    height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-25 {
    min-height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-50 {
    min-height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-75 {
    min-height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .min-vh-xxl-100 {
    min-height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-fill {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-grow-0 {
    -webkit-box-flex: 0 !important;
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-grow-1 {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
}

@media (min-width: 1540px) {
  .flex-xxl-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-0 {
    gap: 0 !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-3 {
    gap: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-4 {
    gap: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-5 {
    gap: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-6 {
    gap: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-7 {
    gap: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-8 {
    gap: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-9 {
    gap: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-10 {
    gap: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .gap-xxl-11 {
    gap: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
}

@media (min-width: 1540px) {
  .justify-content-xxl-evenly {
    -webkit-box-pack: space-evenly !important;
    -ms-flex-pack: space-evenly !important;
    justify-content: space-evenly !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
}

@media (min-width: 1540px) {
  .align-items-xxl-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
}

@media (min-width: 1540px) {
  .align-content-xxl-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
}

@media (min-width: 1540px) {
  .align-self-xxl-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-first {
    -webkit-box-ordinal-group: 0 !important;
    -ms-flex-order: -1 !important;
    order: -1 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-0 {
    -webkit-box-ordinal-group: 1 !important;
    -ms-flex-order: 0 !important;
    order: 0 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-1 {
    -webkit-box-ordinal-group: 2 !important;
    -ms-flex-order: 1 !important;
    order: 1 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-2 {
    -webkit-box-ordinal-group: 3 !important;
    -ms-flex-order: 2 !important;
    order: 2 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-3 {
    -webkit-box-ordinal-group: 4 !important;
    -ms-flex-order: 3 !important;
    order: 3 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-4 {
    -webkit-box-ordinal-group: 5 !important;
    -ms-flex-order: 4 !important;
    order: 4 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-5 {
    -webkit-box-ordinal-group: 6 !important;
    -ms-flex-order: 5 !important;
    order: 5 !important;
  }
}

@media (min-width: 1540px) {
  .order-xxl-last {
    -webkit-box-ordinal-group: 7 !important;
    -ms-flex-order: 6 !important;
    order: 6 !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-0 {
    margin: 0 !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-3 {
    margin: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-4 {
    margin: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-5 {
    margin: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-6 {
    margin: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-7 {
    margin: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-8 {
    margin: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-9 {
    margin: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-10 {
    margin: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-11 {
    margin: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-auto {
    margin: auto !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-4 {
    margin-right: 1.8rem !important;
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-6 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-7 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-8 {
    margin-right: 7.5rem !important;
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-9 {
    margin-right: 10rem !important;
    margin-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-10 {
    margin-right: 12.5rem !important;
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-11 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-4 {
    margin-top: 1.8rem !important;
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-6 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-7 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-8 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-9 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-10 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-11 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-4 {
    margin-top: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-6 {
    margin-top: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-7 {
    margin-top: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-8 {
    margin-top: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-9 {
    margin-top: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-10 {
    margin-top: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-11 {
    margin-top: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-auto {
    margin-top: auto !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-0 {
    margin-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-4 {
    margin-right: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-6 {
    margin-right: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-7 {
    margin-right: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-8 {
    margin-right: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-9 {
    margin-right: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-10 {
    margin-right: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-11 {
    margin-right: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-auto {
    margin-right: auto !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-4 {
    margin-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-6 {
    margin-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-7 {
    margin-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-8 {
    margin-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-9 {
    margin-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-10 {
    margin-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-11 {
    margin-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-4 {
    margin-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-6 {
    margin-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-7 {
    margin-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-8 {
    margin-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-9 {
    margin-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-10 {
    margin-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-11 {
    margin-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n3 {
    margin: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n4 {
    margin: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n5 {
    margin: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n6 {
    margin: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n7 {
    margin: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n8 {
    margin: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n9 {
    margin: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n10 {
    margin: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .m-xxl-n11 {
    margin: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n4 {
    margin-right: -1.8rem !important;
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n6 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n7 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n8 {
    margin-right: -7.5rem !important;
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n9 {
    margin-right: -10rem !important;
    margin-left: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n10 {
    margin-right: -12.5rem !important;
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mx-xxl-n11 {
    margin-right: -15rem !important;
    margin-left: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n4 {
    margin-top: -1.8rem !important;
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n6 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n7 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n8 {
    margin-top: -7.5rem !important;
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n9 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n10 {
    margin-top: -12.5rem !important;
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .my-xxl-n11 {
    margin-top: -15rem !important;
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n4 {
    margin-top: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n6 {
    margin-top: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n7 {
    margin-top: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n8 {
    margin-top: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n9 {
    margin-top: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n10 {
    margin-top: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mt-xxl-n11 {
    margin-top: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n4 {
    margin-right: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n6 {
    margin-right: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n7 {
    margin-right: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n8 {
    margin-right: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n9 {
    margin-right: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n10 {
    margin-right: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .me-xxl-n11 {
    margin-right: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n4 {
    margin-bottom: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n6 {
    margin-bottom: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n7 {
    margin-bottom: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n8 {
    margin-bottom: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n9 {
    margin-bottom: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n10 {
    margin-bottom: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .mb-xxl-n11 {
    margin-bottom: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n4 {
    margin-left: -1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n6 {
    margin-left: -4rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n7 {
    margin-left: -5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n8 {
    margin-left: -7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n9 {
    margin-left: -10rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n10 {
    margin-left: -12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ms-xxl-n11 {
    margin-left: -15rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-0 {
    padding: 0 !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-3 {
    padding: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-4 {
    padding: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-5 {
    padding: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-6 {
    padding: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-7 {
    padding: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-8 {
    padding: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-9 {
    padding: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-10 {
    padding: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .p-xxl-11 {
    padding: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-4 {
    padding-right: 1.8rem !important;
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-6 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-7 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-8 {
    padding-right: 7.5rem !important;
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-9 {
    padding-right: 10rem !important;
    padding-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-10 {
    padding-right: 12.5rem !important;
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .px-xxl-11 {
    padding-right: 15rem !important;
    padding-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-4 {
    padding-top: 1.8rem !important;
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-6 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-7 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-8 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-9 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-10 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .py-xxl-11 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-4 {
    padding-top: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-6 {
    padding-top: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-7 {
    padding-top: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-8 {
    padding-top: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-9 {
    padding-top: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-10 {
    padding-top: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pt-xxl-11 {
    padding-top: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-4 {
    padding-right: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-6 {
    padding-right: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-7 {
    padding-right: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-8 {
    padding-right: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-9 {
    padding-right: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-10 {
    padding-right: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pe-xxl-11 {
    padding-right: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-4 {
    padding-bottom: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-6 {
    padding-bottom: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-7 {
    padding-bottom: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-8 {
    padding-bottom: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-9 {
    padding-bottom: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-10 {
    padding-bottom: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .pb-xxl-11 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-4 {
    padding-left: 1.8rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-6 {
    padding-left: 4rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-7 {
    padding-left: 5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-8 {
    padding-left: 7.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-9 {
    padding-left: 10rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-10 {
    padding-left: 12.5rem !important;
  }
}

@media (min-width: 1540px) {
  .ps-xxl-11 {
    padding-left: 15rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl--2 {
    font-size: 0.69444rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl--1 {
    font-size: 0.83333rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-0 {
    font-size: 1rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-1 {
    font-size: 1.2rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-2 {
    font-size: 1.44rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-3 {
    font-size: 1.728rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-4 {
    font-size: 2.0736rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-5 {
    font-size: 2.48832rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-6 {
    font-size: 2.98598rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-7 {
    font-size: 3.58318rem !important;
  }
}

@media (min-width: 1540px) {
  .fs-xxl-8 {
    font-size: 4.29982rem !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-start {
    text-align: left !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-end {
    text-align: right !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top {
    border-top-start-radius: 0.25rem !important;
    border-top-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top-lg {
    border-top-start-radius: 1.25rem !important;
    border-top-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-top-0 {
    border-top-start-radius: 0 !important;
    border-top-end-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end {
    border-top-end-radius: 0.25rem !important;
    border-bottom-end-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end-lg {
    border-top-end-radius: 1.25rem !important;
    border-bottom-end-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-end-0 {
    border-top-end-radius: 0 !important;
    border-bottom-end-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom {
    border-bottom-end-radius: 0.25rem !important;
    border-bottom-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom-lg {
    border-bottom-end-radius: 1.25rem !important;
    border-bottom-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-bottom-0 {
    border-bottom-end-radius: 0 !important;
    border-bottom-start-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start {
    border-bottom-start-radius: 0.25rem !important;
    border-top-start-radius: 0.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start-lg {
    border-bottom-start-radius: 1.25rem !important;
    border-top-start-radius: 1.25rem !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-start-0 {
    border-bottom-start-radius: 0 !important;
    border-top-start-radius: 0 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-0 {
    opacity: 0 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-25 {
    opacity: 0.25 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-50 {
    opacity: 0.5 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-75 {
    opacity: 0.75 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-85 {
    opacity: 0.85 !important;
  }
}

@media (min-width: 1540px) {
  .opacity-xxl-100 {
    opacity: 1 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-facebook {
    color: #3c5a99 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-google-plus {
    color: #dd4b39 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-twitter {
    color: #1da1f2 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-linkedin {
    color: #0077b5 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-youtube {
    color: red !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-github {
    color: #333 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-black {
    color: #000 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-100 {
    color: #fafafa !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-200 {
    color: #e8e5e9 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-300 {
    color: #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-400 {
    color: #d5d1d6 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-500 {
    color: #ccc6cd !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-600 {
    color: #c3bcc4 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-700 {
    color: #b9b1bb !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-800 {
    color: #b0a7b2 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-900 {
    color: #a79ca8 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1000 {
    color: #778295 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1100 {
    color: #44224b !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-1200 {
    color: #091e40 !important;
  }
}

@media (min-width: 1540px) {
  .text-xxl-white {
    color: #fff !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-25 {
    max-height: 25vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-50 {
    max-height: 50vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-75 {
    max-height: 75vh !important;
  }
}

@media (min-width: 1540px) {
  .max-vh-xxl-100 {
    max-height: 100vh !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-x {
    border-left: 1px solid #dfdbdf !important;
    border-right: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-x-0 {
    border-left: 0 !important;
    border-right: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-y {
    border-top: 1px solid #dfdbdf !important;
    border-bottom: 1px solid #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-y-0 {
    border-top: 0 !important;
    border-bottom: 0 !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed {
    border: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-top {
    border-top: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-end {
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-start {
    border-left: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-bottom {
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-x {
    border-left: 1px dashed #dfdbdf !important;
    border-right: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .border-xxl-dashed-y {
    border-top: 1px dashed #dfdbdf !important;
    border-bottom: 1px dashed #dfdbdf !important;
  }
}

@media (min-width: 1540px) {
  .rounded-xxl-0 {
    border-radius: 0 !important;
  }
}

::-webkit-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::-moz-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

:-ms-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::-ms-input-placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

::placeholder {
  opacity: 1;
  color: #d5d1d6 !important;
}

html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: smooth;
  scroll-padding-top: 6.3125rem;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

pre,
code {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

section {
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;
}

@media (min-width: 992px) {
  section {
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }
}

input,
button,
select,
optgroup,
textarea,
label,
.alert,
.badge,
.blockquote-footer,
.btn,
.navbar,
.pagination,
.valid-feedback,
.invalid-feedback {
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

pre {
  margin: 0;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

strong {
  font-weight: 600;
}

label {
  font-weight: 500 !important;
  margin-bottom: 0.5rem;
}

ol,
ul {
  padding-left: 1.1rem;
}

.firefox .dropcap:first-letter {
  margin-top: 0.175em;
}

.chrome .btn-close {
  background-clip: unset;
}

.text-smallcaps {
  font-variant: small-caps;
}

.text-superscript {
  vertical-align: super;
}

.text-word-break {
  word-break: break-word;
}

.font-sans-serif {
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

.font-base {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
}

.fs-error {
  font-size: 7rem;
}

@media (min-width: 576px) {
  .fs-error {
    font-size: 10rem;
  }
}

.text-justify {
  text-align: justify !important;
}

.shape-up {
  margin-top: -21rem;
}

.bg-holder {
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  will-change: transform, opacity, filter;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-repeat: no-repeat;
  z-index: 0;
}

.bg-holder.bg-right {
  left: auto;
  right: 0;
}

.bg-holder.overlay:before {
  position: absolute;
  content: "";
  background: rgba(0, 0, 0, 0.25);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.bg-holder.overlay-0:before {
  background: rgba(0, 0, 0, 0.7);
}

.bg-holder.overlay-1:before {
  background: rgba(0, 0, 0, 0.55);
}

.bg-holder.overlay-2:before {
  background: rgba(0, 0, 0, 0.4);
}

.bg-holder .bg-video {
  position: absolute;
  display: block;
  z-index: -1;
  top: 0;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
  min-width: 100%;
}

.bg-holder .bg-youtube {
  position: absolute !important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.bg-light-gradient {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(236, 240, 253, 0)),
    color-stop(14.32%, rgba(236, 240, 253, 0.53)),
    color-stop(45.83%, #ecf0fd),
    color-stop(84.33%, rgba(236, 240, 253, 0.43)),
    to(rgba(236, 240, 253, 0))
  );
  background: -o-linear-gradient(
    top,
    rgba(236, 240, 253, 0) 0%,
    rgba(236, 240, 253, 0.53) 14.32%,
    #ecf0fd 45.83%,
    rgba(236, 240, 253, 0.43) 84.33%,
    rgba(236, 240, 253, 0) 100%
  );
  background: linear-gradient(
    180deg,
    rgba(236, 240, 253, 0) 0%,
    rgba(236, 240, 253, 0.53) 14.32%,
    #ecf0fd 45.83%,
    rgba(236, 240, 253, 0.43) 84.33%,
    rgba(236, 240, 253, 0) 100%
  );
}

.bg-primary-gradient {
  background: -o-linear-gradient(241.82deg, #51b4f7 9.05%, #5a98f2 76.74%);
  background: linear-gradient(208.18deg, #51b4f7 9.05%, #5a98f2 76.74%);
}

.overflow-hidden[class*="rounded"] {
  -webkit-mask-image: radial-gradient(#fff, #000);
  mask-image: radial-gradient(#fff, #000);
}

.border-top-2 {
  border-top-width: 0.125rem !important;
}

.border-end-2 {
  border-right-width: 0.125rem !important;
}

.border-bottom-2 {
  border-bottom-width: 0.125rem !important;
}

.border-start-2 {
  border-left-width: 0.125rem !important;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  position: relative;
}

.all-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.flex-center {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.flex-between-center {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-end-center {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.link-black {
  color: #000 !important;
}

.link-black:hover,
.link-black:focus {
  color: #000 !important;
}

.link-100 {
  color: #fafafa !important;
}

.link-100:hover,
.link-100:focus {
  color: #d4d4d4 !important;
}

.link-200 {
  color: #e8e5e9 !important;
}

.link-200:hover,
.link-200:focus {
  color: #c3bcc6 !important;
}

.link-300 {
  color: #dfdbdf !important;
}

.link-300:hover,
.link-300:focus {
  color: #bbb3bb !important;
}

.link-400 {
  color: #d5d1d6 !important;
}

.link-400:hover,
.link-400:focus {
  color: #b0a9b2 !important;
}

.link-500 {
  color: #ccc6cd !important;
}

.link-500:hover,
.link-500:focus {
  color: #a89da9 !important;
}

.link-600 {
  color: #c3bcc4 !important;
}

.link-600:hover,
.link-600:focus {
  color: #9f93a0 !important;
}

.link-700 {
  color: #b9b1bb !important;
}

.link-700:hover,
.link-700:focus {
  color: #948897 !important;
}

.link-800 {
  color: #b0a7b2 !important;
}

.link-800:hover,
.link-800:focus {
  color: #8b7e8e !important;
}

.link-900 {
  color: #a79ca8 !important;
}

.link-900:hover,
.link-900:focus {
  color: #827484 !important;
}

.link-1000 {
  color: #778295 !important;
}

.link-1000:hover,
.link-1000:focus {
  color: #545d6c !important;
}

.link-1100 {
  color: #44224b !important;
}

.link-1100:hover,
.link-1100:focus {
  color: #140a16 !important;
}

.link-1200 {
  color: #091e40 !important;
}

.link-1200:hover,
.link-1200:focus {
  color: #000 !important;
}

.link-white {
  color: #fff !important;
}

.link-white:hover,
.link-white:focus {
  color: #d9d9d9 !important;
}

.shadow-transition {
  -webkit-box-shadow: 0 25px 45px rgba(167, 156, 168, 0.075);
  box-shadow: 0 25px 45px rgba(167, 156, 168, 0.075);
  -webkit-transition: -webkit-box-shadow 0.4s ease;
  transition: -webkit-box-shadow 0.4s ease;
  -o-transition: box-shadow 0.4s ease;
  transition: box-shadow 0.4s ease;
  transition: box-shadow 0.4s ease, -webkit-box-shadow 0.4s ease;
}

.icon-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.icon-group .icon-item:not(:last-child) {
  margin-right: 0.5rem;
}

.icon-item {
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #b9b1bb;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  height: 2.5rem;
  width: 2.5rem;
  border: 0;
  font-size: 0.875rem;
  -webkit-box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15);
  box-shadow: 0 1.5625rem 2.8125rem rgba(0, 87, 255, 0.15);
}

.icon-item:hover,
.icon-item:focus {
  background-color: #e8e5e9;
}

.icon-item.icon-item-sm {
  height: 1.875rem;
  width: 1.875rem;
}

.icon-item.icon-item-lg {
  height: 2.75rem;
  width: 2.75rem;
}

.fontawesome-i2svg-active .icon-indicator {
  opacity: 1;
}

.fit-cover {
  -o-object-fit: cover;
  object-fit: cover;
}

.z-index-1 {
  z-index: 1;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index--1 {
  z-index: -1;
}

.sticky-sidebar {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1020;
  top: 5.3125rem;
}

.circle-dashed {
  border: 1px dashed #717cff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
}

.hover-text-decoration-none:hover,
.hover-text-decoration-none:focus {
  text-decoration: none;
}

.resize-none {
  resize: none;
}

.collapsed .collapse-icon {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
}

.collapse-icon {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

[data-dismiss="dropdown"] *,
[data-offset-top] *,
[data-toggle="collapse"] *,
[data-toggle="tooltip"] *,
[data-toggle="popover"] * {
  pointer-events: none;
}

.outline-none {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.outline-none:hover,
.outline-none:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.vertical-line:after {
  position: absolute;
  content: "";
  height: 75%;
  width: 1px;
  background: #dfdbdf;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-line.vertical-line-400:after {
  background-color: #d5d1d6;
}

.transition-base {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.transition-none {
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.fsp-75 {
  font-size: 75%;
}

.min-w-0 {
  min-width: 0;
}

.terms-sidebar .nav-link {
  color: #ccc6cd;
  font-weight: 500;
  font-family: "Poppins", "Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}

.terms-sidebar .nav-link.active {
  color: #717cff;
}

.card-price {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
}

.backdrop {
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}

.btn-glow {
  position: relative;
}

.btn-glow::before {
  content: "";
  height: 80%;
  width: 80%;
  position: absolute;
  top: 10%;
  left: 10%;
  display: inline-block;
  background-color: inherit;
  opacity: 0.55;
  -webkit-filter: blur(26px);
  filter: blur(26px);
  -webkit-transform: translateY(45%);
  -ms-transform: translateY(45%);
  transform: translateY(45%);
  z-index: -1;
  border-radius: 10px;
}

.hover-top {
  -webkit-transform: translateY(0) translateZ(0);
  transform: translateY(0) translateZ(0);
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.hover-top.hover-top-shadow-lg:hover,
.hover-top.hover-top-shadow-lg:focus {
  -webkit-transform: translateY(-0.3125rem) translateZ(0);
  transform: translateY(-0.3125rem) translateZ(0);
}

.hover-top:hover,
.hover-top:focus {
  -webkit-transform: translateY(-0.125rem) translateZ(0);
  transform: translateY(-0.125rem) translateZ(0);
  -webkit-box-shadow: 0.5rem 0.5rem 1.5rem rgba(22, 28, 45, 0.1) !important;
  box-shadow: 0.5rem 0.5rem 1.5rem rgba(22, 28, 45, 0.1) !important;
  background-color: #016b9d;
  color: #fff;
}

.hover-top:hover .heading-color,
.hover-top:focus .heading-color {
  color: #fff;
}

.badge {
  line-height: 0.8125rem;
}

.badge-circle {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.5rem;
}

@media (min-width: 768px) {
  .badge-circle {
    height: 3.4rem;
    width: 3.4rem;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 1rem;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  color: #778295;
  text-align: center;
  opacity: 0.9;
  -webkit-transition: opacity 0.15s ease;
  -o-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #778295;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-indicators {
  position: static;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  margin: 0;
}

.carousel-indicators li {
  border-radius: 50%;
}

.carousel-indicators .active {
  opacity: 1;
  background-color: #717cff;
  width: 8px;
  height: 8px;
}

.carousel-control-prev {
  left: auto;
  right: 45px;
}

.card-span {
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  border: 0;
}

.card-span .card-span-img {
  position: absolute;
  left: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
}

.input-group {
  position: relative;
}

.input-group .input-box {
  padding-left: 2.2rem;
  vertical-align: middle;
}

.input-group .input-box-icon {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

/* # sourceMappingURL=theme.min.css.map */

.cabang-card {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    background-color: transparent;
    border-radius: 12px;
    padding: 15px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cabang-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
}

.cabang-card img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.cabang-link {
    display: block;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue